const dataDivertissement = {
    id4000: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Queen a sorti Bohemian Rhapsody ?",
      answers: ["1992","1995","1975","1958"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4001: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Bohemian Rhapsody en 1975 ?",
      answers: ["Madonna","Queen","Rihanna ft. Jay-Z","ABBA"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4002: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Queen sortie en 1975 ?",
      answers: ["Bohemian Rhapsody","Billie Jean","I Gotta Feeling","Like a Rolling Stone"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4003: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année John Lennon a sorti Imagine ?",
      answers: ["2017","1983","1971","1947"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4004: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Imagine en 1971 ?",
      answers: ["The Beatles","Lil Nas X ft. Billy Ray Cyrus","Guns N' Roses","John Lennon"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4005: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de John Lennon sortie en 1971 ?",
      answers: ["Imagine","What a Wonderful World","No Woman, No Cry","Toxic"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4006: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Bob Dylan a sorti Like a Rolling Stone ?",
      answers: ["1972","1965","1967","1984"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4007: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Like a Rolling Stone en 1965 ?",
      answers: ["Britney Spears","Led Zeppelin","Bob Dylan","Michael Jackson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4008: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Bob Dylan sortie en 1965 ?",
      answers: ["Rolling in the Deep","Good Vibrations","Smells Like Teen Spirit","Like a Rolling Stone"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4009: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année The Beatles a sorti Hey Jude ?",
      answers: ["1968","1969","1982","2003"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4010: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Hey Jude en 1968 ?",
      answers: ["Britney Spears","The Beatles","Bruce Springsteen","Michael Jackson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4011: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de The Beatles sortie en 1968 ?",
      answers: ["Uptown Funk","Single Ladies (Put a Ring on It)","Rolling in the Deep","Hey Jude"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4012: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Michael Jackson a sorti Billie Jean ?",
      answers: ["2017","1983","1984","1976"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4013: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Billie Jean en 1983 ?",
      answers: ["Michael Jackson","The Beatles","Eminem","Leonard Cohen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4014: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Michael Jackson sortie en 1983 ?",
      answers: ["Rolling in the Deep","Imagine","Wonderwall","Billie Jean"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4015: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Nirvana a sorti Smells Like Teen Spirit ?",
      answers: ["1991","1965","1992","1971"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4016: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Smells Like Teen Spirit en 1991 ?",
      answers: ["John Lennon","Michael Jackson","Stevie Wonder","Nirvana"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4017: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Nirvana sortie en 1991 ?",
      answers: ["I Will Always Love You","Smells Like Teen Spirit","Bohemian Rhapsody","I Gotta Feeling"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4018: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Guns N' Roses a sorti Sweet Child O' Mine ?",
      answers: ["1987","2010","1975","1974"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4019: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Sweet Child O' Mine en 1987 ?",
      answers: ["The Black Eyed Peas","Guns N' Roses","Adele","Leonard Cohen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4020: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Guns N' Roses sortie en 1987 ?",
      answers: ["Hotel California","Sweet Child O' Mine","Like a Rolling Stone","Wannabe"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4021: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Led Zeppelin a sorti Stairway to Heaven ?",
      answers: ["1969","2019","2017","1971"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4022: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Stairway to Heaven en 1971 ?",
      answers: ["Led Zeppelin","Bob Dylan","Eagles","Aretha Franklin"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4023: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Led Zeppelin sortie en 1971 ?",
      answers: ["Stairway to Heaven","I Gotta Feeling","Viva la Vida","Respect"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4024: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Eagles a sorti Hotel California ?",
      answers: ["1967","2008","1996","1976"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4025: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Hotel California en 1976 ?",
      answers: ["John Denver","Frank Sinatra","Eagles","The Beatles"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4026: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Eagles sortie en 1976 ?",
      answers: ["Respect","Johnny B. Goode","Hotel California","I Gotta Feeling"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4027: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Michael Jackson a sorti Thriller ?",
      answers: ["1982","1974","2009","1984"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4028: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Thriller en 1982 ?",
      answers: ["Nirvana","Michael Jackson","Beyoncé","The Beach Boys"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4029: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Michael Jackson sortie en 1982 ?",
      answers: ["Yesterday","Old Town Road","I Gotta Feeling","Thriller"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4030: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année The Beatles a sorti Yesterday ?",
      answers: ["1991","1939","2017","1965"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4031: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Yesterday en 1965 ?",
      answers: ["Santana ft. Rob Thomas","The Beatles","John Lennon","Lil Nas X ft. Billy Ray Cyrus"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4032: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de The Beatles sortie en 1965 ?",
      answers: ["Old Town Road","Yesterday","Single Ladies (Put a Ring on It)","Like a Rolling Stone"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4033: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Prince a sorti Purple Rain ?",
      answers: ["1984","2014","1974","2017"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4034: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Purple Rain en 1984 ?",
      answers: ["Édith Piaf","The Beatles","Prince","The Beach Boys"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4035: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Prince sortie en 1984 ?",
      answers: ["Bohemian Rhapsody","Rolling in the Deep","Purple Rain","Shape of You"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4036: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Bruce Springsteen a sorti Born to Run ?",
      answers: ["1975","2002","1958","1970"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4037: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Born to Run en 1975 ?",
      answers: ["Lil Nas X ft. Billy Ray Cyrus","Nirvana","Spice Girls","Bruce Springsteen"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4038: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Bruce Springsteen sortie en 1975 ?",
      answers: ["Old Town Road","Viva la Vida","Smooth","Born to Run"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4039: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Whitney Houston a sorti I Will Always Love You ?",
      answers: ["1992","1991","1984","2019"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4040: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti I Will Always Love You en 1992 ?",
      answers: ["Eminem","Whitney Houston","Madonna","Bob Marley & The Wailers"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4041: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Whitney Houston sortie en 1992 ?",
      answers: ["Rolling in the Deep","I Will Always Love You","Toxic","Over the Rainbow"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4042: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Madonna a sorti Like a Virgin ?",
      answers: ["1984","1947","2008","1972"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4043: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Like a Virgin en 1984 ?",
      answers: ["Adele","The Police","Madonna","Bob Marley & The Wailers"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4044: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Madonna sortie en 1984 ?",
      answers: ["Dancing Queen","Gangnam Style","Despacito","Like a Virgin"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4045: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année The Beatles a sorti Let It Be ?",
      answers: ["1970","2010","1991","1983"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4046: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Let It Be en 1970 ?",
      answers: ["PSY","The Beatles","ABBA","The Beach Boys"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4047: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de The Beatles sortie en 1970 ?",
      answers: ["Purple Rain","I Will Always Love You","Let It Be","Thriller"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4048: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Adele a sorti Rolling in the Deep ?",
      answers: ["2010","1983","2008","1975"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4049: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Rolling in the Deep en 2010 ?",
      answers: ["Adele","The Weeknd","Madonna","Michael Jackson"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4050: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Adele sortie en 2010 ?",
      answers: ["Stairway to Heaven","Rolling in the Deep","Like a Virgin","Gangnam Style"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4051: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Ed Sheeran a sorti Shape of You ?",
      answers: ["2017","1976","1991","2010"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4052: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Shape of You en 2017 ?",
      answers: ["PSY","Ed Sheeran","Britney Spears","John Lennon"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4053: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Ed Sheeran sortie en 2017 ?",
      answers: ["Born to Run","Proud Mary","Shape of You","Viva la Vida"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4054: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Mark Ronson ft. Bruno Mars a sorti Uptown Funk ?",
      answers: ["1965","2014","1976","1947"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4055: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Uptown Funk en 2014 ?",
      answers: ["Frank Sinatra","Mark Ronson ft. Bruno Mars","Eminem","Lil Nas X ft. Billy Ray Cyrus"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4056: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Mark Ronson ft. Bruno Mars sortie en 2014 ?",
      answers: ["Despacito","Imagine","Uptown Funk","Yesterday"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4057: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Luis Fonsi ft. Daddy Yankee a sorti Despacito ?",
      answers: ["1958","2017","1984","1982"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4058: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Despacito en 2017 ?",
      answers: ["The Beatles","Creedence Clearwater Revival","Lynyrd Skynyrd","Luis Fonsi ft. Daddy Yankee"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4059: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Luis Fonsi ft. Daddy Yankee sortie en 2017 ?",
      answers: ["Despacito","Good Vibrations","Shape of You","Dancing Queen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4060: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Spice Girls a sorti Wannabe ?",
      answers: ["1939","1983","1996","1982"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4061: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Wannabe en 1996 ?",
      answers: ["Spice Girls","Ed Sheeran","Guns N' Roses","Frank Sinatra"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4062: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Spice Girls sortie en 1996 ?",
      answers: ["Like a Virgin","Single Ladies (Put a Ring on It)","Wannabe","Creep"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4063: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année The Beatles a sorti I Want to Hold Your Hand ?",
      answers: ["1939","2017","1963","1947"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4064: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti I Want to Hold Your Hand en 1963 ?",
      answers: ["Creedence Clearwater Revival","PSY","Eminem","The Beatles"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4065: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de The Beatles sortie en 1963 ?",
      answers: ["I Want to Hold Your Hand","Despacito","Smells Like Teen Spirit","Every Breath You Take"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4066: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Stevie Wonder a sorti Superstition ?",
      answers: ["1972","1987","2007","1975"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4067: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Superstition en 1972 ?",
      answers: ["Stevie Wonder","Chuck Berry","Lil Nas X ft. Billy Ray Cyrus","John Denver"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4068: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Stevie Wonder sortie en 1972 ?",
      answers: ["Superstition","I Gotta Feeling","Proud Mary","Viva la Vida"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4069: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Lynyrd Skynyrd a sorti Sweet Home Alabama ?",
      answers: ["1996","1987","1971","1974"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4070: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Sweet Home Alabama en 1974 ?",
      answers: ["The Black Eyed Peas","Coldplay","Lynyrd Skynyrd","Michael Jackson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4071: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Lynyrd Skynyrd sortie en 1974 ?",
      answers: ["Creep","Billie Jean","Lose Yourself","Sweet Home Alabama"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4072: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Leonard Cohen a sorti Hallelujah ?",
      answers: ["2019","1963","1984","1970"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4073: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Hallelujah en 1984 ?",
      answers: ["Creedence Clearwater Revival","Eminem","Leonard Cohen","Mark Ronson ft. Bruno Mars"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4074: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Leonard Cohen sortie en 1984 ?",
      answers: ["Sweet Child O' Mine","Old Town Road","Hallelujah","Umbrella"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4075: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année The Police a sorti Every Breath You Take ?",
      answers: ["2014","1987","1970","1983"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4076: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Every Breath You Take en 1983 ?",
      answers: ["The Police","Prince","Michael Jackson","Bruce Springsteen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4077: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de The Police sortie en 1983 ?",
      answers: ["Uptown Funk","Every Breath You Take","Hey Jude","No Woman, No Cry"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4078: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année ABBA a sorti Dancing Queen ?",
      answers: ["1976","2007","1995","2019"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4079: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Dancing Queen en 1976 ?",
      answers: ["Madonna","ABBA","Led Zeppelin","Bruce Springsteen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4080: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de ABBA sortie en 1976 ?",
      answers: ["Take Me Home, Country Roads","Dancing Queen","Blinding Lights","Like a Virgin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4081: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Édith Piaf a sorti La Vie en Rose ?",
      answers: ["1947","1976","1969","1974"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4082: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti La Vie en Rose en 1947 ?",
      answers: ["Coldplay","The Weeknd","The Beatles","Édith Piaf"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4083: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Édith Piaf sortie en 1947 ?",
      answers: ["Hey Jude","Yesterday","La Vie en Rose","Let It Be"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4084: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Frank Sinatra a sorti My Way ?",
      answers: ["1947","1969","2007","1966"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4085: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti My Way en 1969 ?",
      answers: ["The Beatles","Frank Sinatra","Michael Jackson","John Denver"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4086: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Frank Sinatra sortie en 1969 ?",
      answers: ["My Way","No Woman, No Cry","Bad Guy","Like a Rolling Stone"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4087: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Judy Garland a sorti Over the Rainbow ?",
      answers: ["1939","1995","1991","1971"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4088: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Over the Rainbow en 1939 ?",
      answers: ["The Black Eyed Peas","Radiohead","PSY","Judy Garland"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4089: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Judy Garland sortie en 1939 ?",
      answers: ["Toxic","Gangnam Style","Over the Rainbow","Single Ladies (Put a Ring on It)"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4090: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Aretha Franklin a sorti Respect ?",
      answers: ["2008","1967","2017","1982"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4091: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Respect en 1967 ?",
      answers: ["John Denver","Beyoncé","Luis Fonsi ft. Daddy Yankee","Aretha Franklin"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4092: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Aretha Franklin sortie en 1967 ?",
      answers: ["Proud Mary","Respect","Bohemian Rhapsody","Smooth"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4093: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année The Beach Boys a sorti Good Vibrations ?",
      answers: ["1983","1996","1966","1974"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4094: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Good Vibrations en 1966 ?",
      answers: ["Michael Jackson","The Beach Boys","Louis Armstrong","Radiohead"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4095: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de The Beach Boys sortie en 1966 ?",
      answers: ["Blinding Lights","Yesterday","Good Vibrations","Over the Rainbow"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4096: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Eminem a sorti Lose Yourself ?",
      answers: ["1991","2008","1958","2002"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4097: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Lose Yourself en 2002 ?",
      answers: ["Guns N' Roses","John Denver","Ed Sheeran","Eminem"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4098: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Eminem sortie en 2002 ?",
      answers: ["Yesterday","Lose Yourself","What a Wonderful World","Let It Be"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4099: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Coldplay a sorti Viva la Vida ?",
      answers: ["1996","2019","2008","1982"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4100: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Viva la Vida en 2008 ?",
      answers: ["Bruce Springsteen","Eminem","Coldplay","Bob Marley & The Wailers"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4101: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Coldplay sortie en 2008 ?",
      answers: ["Viva la Vida","Billie Jean","Like a Virgin","Old Town Road"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4102: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Beyoncé a sorti Single Ladies (Put a Ring on It) ?",
      answers: ["2014","2019","1969","2008"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4103: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Single Ladies (Put a Ring on It) en 2008 ?",
      answers: ["Beyoncé","Santana ft. Rob Thomas","Ed Sheeran","The Weeknd"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4104: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Beyoncé sortie en 2008 ?",
      answers: ["Sweet Home Alabama","No Woman, No Cry","Single Ladies (Put a Ring on It)","Respect"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4105: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Billie Eilish a sorti Bad Guy ?",
      answers: ["2019","2007","1976","2012"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4106: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Bad Guy en 2019 ?",
      answers: ["Led Zeppelin","Bob Marley & The Wailers","Billie Eilish","John Lennon"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4107: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Billie Eilish sortie en 2019 ?",
      answers: ["Stairway to Heaven","Like a Rolling Stone","Bohemian Rhapsody","Bad Guy"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4108: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année The Weeknd a sorti Blinding Lights ?",
      answers: ["1983","2019","1974","2002"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4109: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Blinding Lights en 2019 ?",
      answers: ["Mark Ronson ft. Bruno Mars","The Weeknd","PSY","Judy Garland"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4110: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de The Weeknd sortie en 2019 ?",
      answers: ["Smooth","Gangnam Style","Blinding Lights","Bad Guy"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4111: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Lil Nas X ft. Billy Ray Cyrus a sorti Old Town Road ?",
      answers: ["2012","1970","1987","2019"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4112: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Old Town Road en 2019 ?",
      answers: ["The Black Eyed Peas","John Lennon","Michael Jackson","Lil Nas X ft. Billy Ray Cyrus"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4113: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Lil Nas X ft. Billy Ray Cyrus sortie en 2019 ?",
      answers: ["Old Town Road","Rolling in the Deep","Respect","Umbrella"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4114: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année PSY a sorti Gangnam Style ?",
      answers: ["2012","1939","1967","1968"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4115: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Gangnam Style en 2012 ?",
      answers: ["PSY","Stevie Wonder","Michael Jackson","The Beatles"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4116: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de PSY sortie en 2012 ?",
      answers: ["Let It Be","Gangnam Style","Umbrella","Blinding Lights"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4117: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Britney Spears a sorti Toxic ?",
      answers: ["2003","2009","1963","2012"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4118: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Toxic en 2003 ?",
      answers: ["Britney Spears","Eminem","Spice Girls","Michael Jackson"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4119: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Britney Spears sortie en 2003 ?",
      answers: ["I Will Always Love You","Good Vibrations","Respect","Toxic"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4120: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Rihanna ft. Jay-Z a sorti Umbrella ?",
      answers: ["1965","2008","2019","2007"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4121: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Umbrella en 2007 ?",
      answers: ["Rihanna ft. Jay-Z","Prince","ABBA","Judy Garland"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4122: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Rihanna ft. Jay-Z sortie en 2007 ?",
      answers: ["Lose Yourself","Umbrella","Shape of You","No Woman, No Cry"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4123: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Creedence Clearwater Revival a sorti Proud Mary ?",
      answers: ["1974","1969","1984","2019"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4124: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Proud Mary en 1969 ?",
      answers: ["Creedence Clearwater Revival","Madonna","Frank Sinatra","Oasis"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4125: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Creedence Clearwater Revival sortie en 1969 ?",
      answers: ["Dancing Queen","Proud Mary","Hotel California","I Gotta Feeling"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4126: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Santana ft. Rob Thomas a sorti Smooth ?",
      answers: ["1947","1975","1992","1999"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4127: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Smooth en 1999 ?",
      answers: ["Whitney Houston","Led Zeppelin","Eminem","Santana ft. Rob Thomas"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4128: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Santana ft. Rob Thomas sortie en 1999 ?",
      answers: ["Good Vibrations","Hotel California","Smooth","Superstition"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4129: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Oasis a sorti Wonderwall ?",
      answers: ["1947","1969","1995","1984"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4130: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Wonderwall en 1995 ?",
      answers: ["Michael Jackson","Oasis","Billie Eilish","Madonna"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4131: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Oasis sortie en 1995 ?",
      answers: ["I Gotta Feeling","Old Town Road","Sweet Child O' Mine","Wonderwall"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4132: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Radiohead a sorti Creep ?",
      answers: ["1999","2003","1947","1992"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4133: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Creep en 1992 ?",
      answers: ["Mark Ronson ft. Bruno Mars","The Beatles","Radiohead","PSY"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4134: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Radiohead sortie en 1992 ?",
      answers: ["Purple Rain","Creep","Toxic","Blinding Lights"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4135: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Bob Marley & The Wailers a sorti No Woman, No Cry ?",
      answers: ["1966","2019","1974","2002"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4136: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti No Woman, No Cry en 1974 ?",
      answers: ["The Beatles","Bob Marley & The Wailers","Lil Nas X ft. Billy Ray Cyrus","Aretha Franklin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4137: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Bob Marley & The Wailers sortie en 1974 ?",
      answers: ["Like a Rolling Stone","No Woman, No Cry","Rolling in the Deep","Uptown Funk"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4138: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Chuck Berry a sorti Johnny B. Goode ?",
      answers: ["1984","2019","1958","1996"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4139: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Johnny B. Goode en 1958 ?",
      answers: ["Chuck Berry","Guns N' Roses","Édith Piaf","Luis Fonsi ft. Daddy Yankee"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id4140: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Chuck Berry sortie en 1958 ?",
      answers: ["Creep","Johnny B. Goode","Like a Virgin","Imagine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4141: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année Louis Armstrong a sorti What a Wonderful World ?",
      answers: ["1969","1971","1958","1967"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4142: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti What a Wonderful World en 1967 ?",
      answers: ["Bruce Springsteen","John Lennon","Queen","Louis Armstrong"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id4143: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de Louis Armstrong sortie en 1967 ?",
      answers: ["La Vie en Rose","What a Wonderful World","Wonderwall","Let It Be"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4144: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année John Denver a sorti Take Me Home, Country Roads ?",
      answers: ["1967","1984","1971","2019"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4145: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti Take Me Home, Country Roads en 1971 ?",
      answers: ["The Beatles","John Denver","Lil Nas X ft. Billy Ray Cyrus","Billie Eilish"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4146: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de John Denver sortie en 1971 ?",
      answers: ["Old Town Road","Take Me Home, Country Roads","Single Ladies (Put a Ring on It)","Thriller"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id4147: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "En quelle année The Black Eyed Peas a sorti I Gotta Feeling ?",
      answers: ["1984","1939","2009","2019"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4148: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Qui a sorti I Gotta Feeling en 2009 ?",
      answers: ["Madonna","Billie Eilish","The Black Eyed Peas","The Beatles"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id4149: {
      themes: ["Culture Pop","Musique","Divers"],
      question: "Comment s'appelle la chanson de The Black Eyed Peas sortie en 2009 ?",
      answers: ["Bohemian Rhapsody","I Gotta Feeling","Born to Run","I Want to Hold Your Hand"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5000: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Francis Ford Coppola a sorti Le Parrain ?",
      answers: ["1994","1980","2003","1972"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5001: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Le Parrain en 1972 ?",
      answers: ["Francis Ford Coppola","Christopher Nolan","Stanley Kubrick","James Cameron"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5002: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Francis Ford Coppola sorti en 1972 ?",
      answers: ["Le Voyage de Chihiro","Les Évadés","Le Parrain","The Dark Knight"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5003: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Orson Welles a sorti Citizen Kane ?",
      answers: ["1994","1939","1941","1981"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5004: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Citizen Kane en 1941 ?",
      answers: ["Roman Polanski","Orson Welles","James Cameron","Ridley Scott"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5005: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Orson Welles sorti en 1941 ?",
      answers: ["Shining","Citizen Kane","Star Wars : Un nouvel espoir","Le Bon, la Brute et le Truand"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5006: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Quentin Tarantino a sorti Pulp Fiction ?",
      answers: ["1994","2000","2006","1939"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5007: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Pulp Fiction en 1994 ?",
      answers: ["Stanley Kubrick","Steven Spielberg","Quentin Tarantino","Christopher Nolan"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5008: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Quentin Tarantino sorti en 1994 ?",
      answers: ["Le Seigneur des Anneaux : La Communauté de l'Anneau","Oldboy","Casablanca","Pulp Fiction"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5009: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Frank Darabont a sorti Les Évadés ?",
      answers: ["1999","2008","2003","1994"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5010: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Les Évadés en 1994 ?",
      answers: ["Frank Darabont","Steven Spielberg","Roman Polanski","Akira Kurosawa"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5011: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Frank Darabont sorti en 1994 ?",
      answers: ["Les Aventuriers de l'Arche perdue","Les Évadés","2001 : L'Odyssée de l'espace","Psychose"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5012: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année James Cameron a sorti Titanic ?",
      answers: ["2019","1977","1999","1997"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5013: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Titanic en 1997 ?",
      answers: ["Christopher Nolan","James Cameron","Lana & Lilly Wachowski","Ridley Scott"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5014: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de James Cameron sorti en 1997 ?",
      answers: ["Interstellar","Titanic","Les Évadés","Fight Club"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5015: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Christopher Nolan a sorti Inception ?",
      answers: ["1979","1993","2019","2010"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5016: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Inception en 2010 ?",
      answers: ["Christopher Nolan","Ridley Scott","Frank Capra","Sergio Leone"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5017: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Christopher Nolan sorti en 2010 ?",
      answers: ["Inception","La Liste de Schindler","Le Bon, la Brute et le Truand","Les Temps modernes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5018: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Steven Spielberg a sorti La Liste de Schindler ?",
      answers: ["2003","2014","1960","1993"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5019: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé La Liste de Schindler en 1993 ?",
      answers: ["David Fincher","Steven Spielberg","Ridley Scott","William Friedkin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5020: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Steven Spielberg sorti en 1993 ?",
      answers: ["Forrest Gump","Shining","La Liste de Schindler","Avatar"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5021: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année George Lucas a sorti Star Wars : Un nouvel espoir ?",
      answers: ["1999","1977","2003","1941"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5022: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Star Wars : Un nouvel espoir en 1977 ?",
      answers: ["George Lucas","Orson Welles","Christopher Nolan","David Fincher"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5023: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de George Lucas sorti en 1977 ?",
      answers: ["Psychose","La Liste de Schindler","Le Roi Lion","Star Wars : Un nouvel espoir"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5024: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Roger Allers & Rob Minkoff a sorti Le Roi Lion ?",
      answers: ["1994","2014","1981","2003"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5025: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Le Roi Lion en 1994 ?",
      answers: ["Alfred Hitchcock","Francis Ford Coppola","Roger Allers & Rob Minkoff","Steven Spielberg"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5026: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Roger Allers & Rob Minkoff sorti en 1994 ?",
      answers: ["Le Bon, la Brute et le Truand","Le Roi Lion","Citizen Kane","Le Seigneur des Anneaux : La Communauté de l'Anneau"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5027: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Jonathan Demme a sorti Le Silence des agneaux ?",
      answers: ["2015","2019","1982","1991"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5028: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Le Silence des agneaux en 1991 ?",
      answers: ["Jonathan Demme","Michael Curtiz","Frank Capra","Martin Scorsese"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5029: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Jonathan Demme sorti en 1991 ?",
      answers: ["Le Silence des agneaux","Avatar","Interstellar","Autant en emporte le vent"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5030: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Robert Zemeckis a sorti Forrest Gump ?",
      answers: ["1982","1991","2001","1994"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5031: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Forrest Gump en 1994 ?",
      answers: ["Martin Scorsese","Frank Capra","Lana & Lilly Wachowski","Robert Zemeckis"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5032: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Robert Zemeckis sorti en 1994 ?",
      answers: ["Forrest Gump","Les Évadés","Les Temps modernes","2001 : L'Odyssée de l'espace"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5033: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Lana & Lilly Wachowski a sorti Matrix ?",
      answers: ["1994","1981","1999","2019"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5034: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Matrix en 1999 ?",
      answers: ["Jonathan Demme","Steven Spielberg","Lana & Lilly Wachowski","David Fincher"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5035: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Lana & Lilly Wachowski sorti en 1999 ?",
      answers: ["The Dark Knight","Matrix","Les Temps modernes","Le Parrain"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5036: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Alfred Hitchcock a sorti Psychose ?",
      answers: ["1976","1960","2010","1982"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5037: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Psychose en 1960 ?",
      answers: ["Roger Allers & Rob Minkoff","Alfred Hitchcock","Mathieu Kassovitz","Orson Welles"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5038: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Alfred Hitchcock sorti en 1960 ?",
      answers: ["Psychose","Le Dictateur","Réservoir Dogs","Le Voyage de Chihiro"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5039: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Steven Spielberg a sorti Les Dents de la mer ?",
      answers: ["1993","1975","1976","2006"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5040: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Les Dents de la mer en 1975 ?",
      answers: ["Steven Spielberg","Christopher Nolan","Charlie Chaplin","Damien Chazelle"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5041: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Steven Spielberg sorti en 1975 ?",
      answers: ["Blade Runner","Les Temps modernes","Les Dents de la mer","Il était une fois dans l'Ouest"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5042: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Peter Jackson a sorti Le Seigneur des Anneaux : La Communauté de l'Anneau ?",
      answers: ["2001","2015","1980","1939"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5043: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Le Seigneur des Anneaux : La Communauté de l'Anneau en 2001 ?",
      answers: ["Victor Fleming","Francis Ford Coppola","Bong Joon-ho","Peter Jackson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5044: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Peter Jackson sorti en 2001 ?",
      answers: ["La Haine","Whiplash","Le Seigneur des Anneaux : La Communauté de l'Anneau","Jurassic Park"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5045: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Robert Zemeckis a sorti Retour vers le futur ?",
      answers: ["1960","1985","1994","1942"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5046: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Retour vers le futur en 1985 ?",
      answers: ["Bong Joon-ho","Robert Zemeckis","Quentin Tarantino","Steven Spielberg"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5047: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Robert Zemeckis sorti en 1985 ?",
      answers: ["Matrix","Il était une fois dans l'Ouest","Retour vers le futur","Forrest Gump"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5048: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Steven Spielberg a sorti Jurassic Park ?",
      answers: ["1994","2000","1993","1991"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5049: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Jurassic Park en 1993 ?",
      answers: ["Steven Spielberg","Victor Fleming","George Miller","Charlie Chaplin"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5050: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Steven Spielberg sorti en 1993 ?",
      answers: ["Apocalypse Now","Jurassic Park","Le Roi Lion","Les Dents de la mer"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5051: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Charlie Chaplin a sorti Le Dictateur ?",
      answers: ["1940","1975","1977","2000"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5052: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Le Dictateur en 1940 ?",
      answers: ["Charlie Chaplin","Robert Zemeckis","Jonathan Demme","Christopher Nolan"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5053: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Charlie Chaplin sorti en 1940 ?",
      answers: ["Retour vers le futur","Le Dictateur","Réservoir Dogs","2001 : L'Odyssée de l'espace"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5054: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Ridley Scott a sorti Blade Runner ?",
      answers: ["1994","1977","1954","1982"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5055: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Blade Runner en 1982 ?",
      answers: ["William Friedkin","Mathieu Kassovitz","Ridley Scott","Alfred Hitchcock"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5056: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Ridley Scott sorti en 1982 ?",
      answers: ["Jurassic Park","Les Sept Samouraïs","La La Land","Blade Runner"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5057: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Francis Ford Coppola a sorti Apocalypse Now ?",
      answers: ["2014","1941","1979","1973"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5058: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Apocalypse Now en 1979 ?",
      answers: ["Francis Ford Coppola","Frank Darabont","Peter Jackson","Steven Spielberg"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5059: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Francis Ford Coppola sorti en 1979 ?",
      answers: ["Matrix","Citizen Kane","Apocalypse Now","Les Aventuriers de l'Arche perdue"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5060: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Stanley Kubrick a sorti 2001 : L'Odyssée de l'espace ?",
      answers: ["1946","1968","1982","2000"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5061: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé 2001 : L'Odyssée de l'espace en 1968 ?",
      answers: ["Steven Spielberg","Stanley Kubrick","Damien Chazelle","Frank Capra"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5062: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Stanley Kubrick sorti en 1968 ?",
      answers: ["2001 : L'Odyssée de l'espace","Le Voyage de Chihiro","Gladiator","Oldboy"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5063: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Stanley Kubrick a sorti Shining ?",
      answers: ["2000","1999","1980","1972"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5064: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Shining en 1980 ?",
      answers: ["Jean-Pierre Jeunet","Ridley Scott","Stanley Kubrick","Sergio Leone"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5065: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Stanley Kubrick sorti en 1980 ?",
      answers: ["Shining","Réservoir Dogs","Le Parrain","Le Fabuleux Destin d'Amélie Poulain"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5066: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Charlie Chaplin a sorti Les Temps modernes ?",
      answers: ["1960","1946","1936","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5067: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Les Temps modernes en 1936 ?",
      answers: ["James Cameron","Lana & Lilly Wachowski","Ridley Scott","Charlie Chaplin"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5068: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Charlie Chaplin sorti en 1936 ?",
      answers: ["Casablanca","La Haine","Les Temps modernes","Pulp Fiction"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5069: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année David Fincher a sorti Fight Club ?",
      answers: ["1999","1939","1985","2008"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5070: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Fight Club en 1999 ?",
      answers: ["Victor Fleming","David Fincher","Ridley Scott","Jean-Pierre Jeunet"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5071: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de David Fincher sorti en 1999 ?",
      answers: ["Le Voyage de Chihiro","Taxi Driver","Fight Club","Le Parrain"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5072: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Steven Spielberg a sorti E.T. l'extra-terrestre ?",
      answers: ["1994","1982","2009","2006"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5073: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé E.T. l'extra-terrestre en 1982 ?",
      answers: ["Steven Spielberg","Martin Scorsese","Christopher Nolan","Stanley Kubrick"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5074: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Steven Spielberg sorti en 1982 ?",
      answers: ["E.T. l'extra-terrestre","L'Exorciste","Les Temps modernes","Titanic"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5075: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Steven Spielberg a sorti Les Aventuriers de l'Arche perdue ?",
      answers: ["1995","2002","1981","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5076: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Les Aventuriers de l'Arche perdue en 1981 ?",
      answers: ["Steven Spielberg","George Miller","Sergio Leone","Charlie Chaplin"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5077: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Steven Spielberg sorti en 1981 ?",
      answers: ["La La Land","L'Exorciste","Matrix","Les Aventuriers de l'Arche perdue"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5078: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Sergio Leone a sorti Le Bon, la Brute et le Truand ?",
      answers: ["2000","1966","2009","1941"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5079: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Le Bon, la Brute et le Truand en 1966 ?",
      answers: ["Robert Zemeckis","Stanley Kubrick","Steven Spielberg","Sergio Leone"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5080: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Sergio Leone sorti en 1966 ?",
      answers: ["Star Wars : Un nouvel espoir","La Liste de Schindler","Le Bon, la Brute et le Truand","Le Parrain"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5081: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Damien Chazelle a sorti La La Land ?",
      answers: ["2016","1979","1995","1999"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5082: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé La La Land en 2016 ?",
      answers: ["Mathieu Kassovitz","David Fincher","Damien Chazelle","Roman Polanski"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5083: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Damien Chazelle sorti en 2016 ?",
      answers: ["Mad Max : Fury Road","Le Bon, la Brute et le Truand","La La Land","Les Infiltrés"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5084: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Bong Joon-ho a sorti Parasite ?",
      answers: ["2019","1966","1981","1979"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5085: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Parasite en 2019 ?",
      answers: ["Robert Zemeckis","Damien Chazelle","Ridley Scott","Bong Joon-ho"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5086: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Bong Joon-ho sorti en 2019 ?",
      answers: ["Whiplash","Le Silence des agneaux","Le Bon, la Brute et le Truand","Parasite"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5087: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année James Cameron a sorti Avatar ?",
      answers: ["2001","1995","1991","2009"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5088: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Avatar en 2009 ?",
      answers: ["Francis Ford Coppola","Hayao Miyazaki","James Cameron","Christopher Nolan"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5089: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de James Cameron sorti en 2009 ?",
      answers: ["Jurassic Park","Memento","Le Roi Lion","Avatar"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5090: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Hayao Miyazaki a sorti Le Voyage de Chihiro ?",
      answers: ["2015","2014","2001","2009"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5091: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Le Voyage de Chihiro en 2001 ?",
      answers: ["Francis Ford Coppola","Hayao Miyazaki","Park Chan-wook","Jean-Pierre Jeunet"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5092: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Hayao Miyazaki sorti en 2001 ?",
      answers: ["Blade Runner","Le Voyage de Chihiro","Les Sept Samouraïs","Il était une fois dans l'Ouest"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5093: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Akira Kurosawa a sorti Les Sept Samouraïs ?",
      answers: ["1993","1939","2002","1954"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5094: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Les Sept Samouraïs en 1954 ?",
      answers: ["Steven Spielberg","Akira Kurosawa","Christopher Nolan","Martin Scorsese"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5095: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Akira Kurosawa sorti en 1954 ?",
      answers: ["Les Temps modernes","2001 : L'Odyssée de l'espace","Avatar","Les Sept Samouraïs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5096: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Michael Curtiz a sorti Casablanca ?",
      answers: ["1992","1968","1942","1946"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5097: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Casablanca en 1942 ?",
      answers: ["Michael Curtiz","James Cameron","Mathieu Kassovitz","Martin Scorsese"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5098: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Michael Curtiz sorti en 1942 ?",
      answers: ["Interstellar","La La Land","La Haine","Casablanca"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5099: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Victor Fleming a sorti Autant en emporte le vent ?",
      answers: ["1939","1960","1941","1973"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5100: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Autant en emporte le vent en 1939 ?",
      answers: ["James Cameron","Victor Fleming","Jean-Pierre Jeunet","William Friedkin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5101: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Victor Fleming sorti en 1939 ?",
      answers: ["Réservoir Dogs","Le Silence des agneaux","Le Voyage de Chihiro","Autant en emporte le vent"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5102: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Frank Capra a sorti La Vie est belle ?",
      answers: ["1993","1946","1973","1980"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5103: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé La Vie est belle en 1946 ?",
      answers: ["Robert Zemeckis","Orson Welles","Steven Spielberg","Frank Capra"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5104: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Frank Capra sorti en 1946 ?",
      answers: ["La Vie est belle","Autant en emporte le vent","2001 : L'Odyssée de l'espace","Les Dents de la mer"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5105: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Martin Scorsese a sorti Les Infiltrés ?",
      answers: ["1942","2010","2006","2019"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5106: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Les Infiltrés en 2006 ?",
      answers: ["Stanley Kubrick","Steven Spielberg","Jean-Pierre Jeunet","Martin Scorsese"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5107: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Martin Scorsese sorti en 2006 ?",
      answers: ["Forrest Gump","Les Infiltrés","The Dark Knight","Le Seigneur des Anneaux : La Communauté de l'Anneau"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5108: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Martin Scorsese a sorti Taxi Driver ?",
      answers: ["1975","2016","1976","1939"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5109: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Taxi Driver en 1976 ?",
      answers: ["Robert Zemeckis","Steven Spielberg","Martin Scorsese","Quentin Tarantino"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5110: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Martin Scorsese sorti en 1976 ?",
      answers: ["Taxi Driver","Blade Runner","La Vie est belle","Forrest Gump"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5111: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année George Miller a sorti Mad Max : Fury Road ?",
      answers: ["1946","2015","1939","2001"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5112: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Mad Max : Fury Road en 2015 ?",
      answers: ["Charlie Chaplin","George Miller","Jean-Pierre Jeunet","Stanley Kubrick"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5113: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de George Miller sorti en 2015 ?",
      answers: ["Gladiator","Les Évadés","Parasite","Mad Max : Fury Road"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5114: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Roman Polanski a sorti Le Pianiste ?",
      answers: ["2002","1973","1999","1993"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5115: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Le Pianiste en 2002 ?",
      answers: ["Charlie Chaplin","Roman Polanski","Alfred Hitchcock","Mathieu Kassovitz"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5116: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Roman Polanski sorti en 2002 ?",
      answers: ["Le Pianiste","Shining","Citizen Kane","Parasite"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5117: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Ridley Scott a sorti Gladiator ?",
      answers: ["1976","2000","2006","1939"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5118: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Gladiator en 2000 ?",
      answers: ["Bong Joon-ho","Ridley Scott","Charlie Chaplin","Stanley Kubrick"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5119: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Ridley Scott sorti en 2000 ?",
      answers: ["Apocalypse Now","Gladiator","L'Exorciste","Le Roi Lion"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5120: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année William Friedkin a sorti L'Exorciste ?",
      answers: ["1973","1982","1972","2008"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5121: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé L'Exorciste en 1973 ?",
      answers: ["Christopher Nolan","William Friedkin","Peter Jackson","James Cameron"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5122: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de William Friedkin sorti en 1973 ?",
      answers: ["L'Exorciste","Matrix","2001 : L'Odyssée de l'espace","Mad Max : Fury Road"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5123: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Sergio Leone a sorti Il était une fois dans l'Ouest ?",
      answers: ["1999","2014","1968","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5124: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Il était une fois dans l'Ouest en 1968 ?",
      answers: ["Michael Curtiz","Roger Allers & Rob Minkoff","Frank Darabont","Sergio Leone"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5125: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Sergio Leone sorti en 1968 ?",
      answers: ["Il était une fois dans l'Ouest","Le Fabuleux Destin d'Amélie Poulain","La Haine","Inception"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5126: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Jean-Pierre Jeunet a sorti Le Fabuleux Destin d'Amélie Poulain ?",
      answers: ["1991","1968","2001","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5127: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Le Fabuleux Destin d'Amélie Poulain en 2001 ?",
      answers: ["Steven Spielberg","Jean-Pierre Jeunet","Park Chan-wook","James Cameron"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5128: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Jean-Pierre Jeunet sorti en 2001 ?",
      answers: ["Les Aventuriers de l'Arche perdue","La Vie est belle","Matrix","Le Fabuleux Destin d'Amélie Poulain"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5129: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Christopher Nolan a sorti The Dark Knight ?",
      answers: ["2008","1946","2015","1940"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5130: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé The Dark Knight en 2008 ?",
      answers: ["Christopher Nolan","Park Chan-wook","Roger Allers & Rob Minkoff","Steven Spielberg"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5131: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Christopher Nolan sorti en 2008 ?",
      answers: ["The Dark Knight","Jurassic Park","Oldboy","Le Fabuleux Destin d'Amélie Poulain"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5132: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Christopher Nolan a sorti Interstellar ?",
      answers: ["1981","2014","1999","2015"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5133: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Interstellar en 2014 ?",
      answers: ["Christopher Nolan","Ridley Scott","Martin Scorsese","Stanley Kubrick"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5134: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Christopher Nolan sorti en 2014 ?",
      answers: ["Réservoir Dogs","Interstellar","E.T. l'extra-terrestre","The Dark Knight"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5135: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Quentin Tarantino a sorti Réservoir Dogs ?",
      answers: ["1992","1991","2009","2001"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5136: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Réservoir Dogs en 1992 ?",
      answers: ["George Lucas","Roman Polanski","Quentin Tarantino","Alfred Hitchcock"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5137: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Quentin Tarantino sorti en 1992 ?",
      answers: ["Les Aventuriers de l'Arche perdue","Les Dents de la mer","Réservoir Dogs","Oldboy"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id5138: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Christopher Nolan a sorti Memento ?",
      answers: ["2000","2002","2006","1939"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5139: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Memento en 2000 ?",
      answers: ["Jean-Pierre Jeunet","Christopher Nolan","Victor Fleming","Francis Ford Coppola"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5140: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Christopher Nolan sorti en 2000 ?",
      answers: ["Inception","Memento","Les Infiltrés","Les Dents de la mer"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5141: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Mathieu Kassovitz a sorti La Haine ?",
      answers: ["1982","1995","1976","2014"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5142: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé La Haine en 1995 ?",
      answers: ["James Cameron","Mathieu Kassovitz","Sergio Leone","Christopher Nolan"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5143: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Mathieu Kassovitz sorti en 1995 ?",
      answers: ["La Haine","Le Voyage de Chihiro","Titanic","Le Pianiste"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id5144: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Park Chan-wook a sorti Oldboy ?",
      answers: ["1939","2003","1994","1946"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5145: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Oldboy en 2003 ?",
      answers: ["Bong Joon-ho","Park Chan-wook","Charlie Chaplin","Christopher Nolan"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id5146: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Park Chan-wook sorti en 2003 ?",
      answers: ["Le Voyage de Chihiro","Psychose","Le Silence des agneaux","Oldboy"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5147: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "En quelle année Damien Chazelle a sorti Whiplash ?",
      answers: ["1939","2006","1994","2014"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5148: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Qui a réalisé Whiplash en 2014 ?",
      answers: ["George Lucas","Stanley Kubrick","Steven Spielberg","Damien Chazelle"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id5149: {
      themes: ["Culture Pop","Cinéma","Divers"],
      question: "Comment s'appelle le film de Damien Chazelle sorti en 2014 ?",
      answers: ["Whiplash","Le Bon, la Brute et le Truand","Inception","Les Sept Samouraïs"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
  },

  id8000: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel animateur a présenté Fort Boyard le plus longtemps ?",
    answers: ["Patrice Laffont", "Olivier Minne", "Jean-Pierre Castaldi", "Cendrine Dominguez"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8001: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "En quelle année Fort Boyard a-t-il été diffusé pour la première fois en France ?",
    answers: ["1989", "1990", "1991", "1992"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8002: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel personnage distribue les énigmes dans la salle du Conseil ?",
    answers: ["Père Fouras", "Félindra", "Passe-Partout", "La Boule"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8003: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel animal est associé à Félindra dans l’émission ?",
    answers: ["Lion", "Tigre", "Panthère", "Léopard"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8004: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Comment s’appelle la pièce où les candidats affrontent les Maîtres du Temps ?",
    answers: ["Salle du Trésor", "Salle du Conseil", "Vigie", "Cellule 13"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8005: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom du nain qui guide les candidats dans le fort ?",
    answers: ["Passe-Muraille", "Passe-Partout", "Passe-Temps", "Passe-Vite"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8006: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel objet les candidats doivent-ils récupérer dans les cellules ?",
    answers: ["Clé", "Indice", "Cristal", "Boyard"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8007: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de la monnaie utilisée dans Fort Boyard ?",
    answers: ["Euro", "Franc", "Boyard", "Ducat"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id8008: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Dans quelle région de France se trouve le Fort Boyard ?",
    answers: ["Bretagne", "Normandie", "Nouvelle-Aquitaine", "Provence"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id8009: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel personnage sonne le gong au début des épreuves ?",
    answers: ["La Boule", "Père Fouras", "Félindra", "Passe-Partout"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8010: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Comment s’intitule l’épreuve où les candidats doivent progresser sur des cordes ?",
    answers: ["Tête chercheuse", "Araignée", "Pont de singe", "Saut de l’ange"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id8011: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel animateur a succédé à Patrice Laffont en 2000 ?",
    answers: ["Olivier Minne", "Jean-Pierre Castaldi", "Nagui", "Vincent Lagaf’"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8012: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Que fait Passe-Muraille dans Fort Boyard depuis 2011 ?",
    answers: [
      "Livrer les parchemins et accompagner les candidats à s’équiper", 
      "Sonner le gong et surveiller les prisonniers", 
      "Créer les énigmes avec le Père Fouras", 
      "Guider les candidats dans les épreuves"
    ],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8013: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quelle épreuve implique de plonger dans un bassin rempli d’eau ?",
    answers: ["Cabine abandonnée", "Cellule qui rétrécit", "Égout", "Prison sous-marine"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id8014: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom du lieu où les candidats récupèrent les Boyards ?",
    answers: ["Salle du Trésor", "Vigie", "Conseil", "Cachot"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8015: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel sport est souvent représenté dans les épreuves physiques ?",
    answers: ["Natation", "Escalade", "Boxe", "Course"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8016: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel personnage est connu pour ses énigmes tordues ?",
    answers: ["Père Fouras", "Félindra", "La Boule", "Passe-Partout"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8017: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de l’épreuve avec des insectes et des reptiles ?",
    answers: ["Casino", "Ketchuperie", "Fosse", "Maison des horreurs"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id8018: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Combien de clés les candidats doivent-ils généralement collecter ?",
    answers: ["5", "7", "9", "11"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8019: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de l’épreuve où un candidat saute dans le vide ?",
    answers: ["Saut de l’ange", "Tyrolienne", "Pont de singe", "Échelle infernale"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8020: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel animateur a présenté Fort Boyard entre 2000 et 2002 ?",
    answers: ["Patrice Laffont", "Jean-Pierre Castaldi", "Olivier Minne", "Anne-Gaëlle Riccio"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8021: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de l'objet que La Boule frappait ?",
    answers: ["Gong", "Cloche d’or", "Carillon", "Clochette"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8022: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de l’épreuve où les candidats doivent viser avec une arbalète ?",
    answers: ["Tir à l’arc", "Arbalète", "Fléchettes", "Lancer précis"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8023: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel personnage est le gardien des tigres ?",
    answers: ["Félindra", "Père Fouras", "La Boule", "Passe-Muraille"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8024: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de l’épreuve où les candidats doivent ramper dans un tunnel ?",
    answers: ["Égout", "Labyrinthe", "Tuyau", "Passage secret"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8025: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom du bateau qui transporte les candidats au fort ?",
    answers: ["Le Boyard", "L’Aventure", "Le Fortuné", "Aucun bateau"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id8026: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de l’épreuve où les candidats doivent tourner un pédallier ?",
    answers: ["Manolier", "Tourniquet", "Roue infernale", "Manivelle"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8027: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de la tour où Père Fouras pose ses énigmes ?",
    answers: ["Vigie", "Tour centrale", "Donjon", "Observatoire"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8028: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de l’épreuve où les candidats doivent marcher sur une poutre ?",
    answers: ["Pont suspendu", "Poutre", "Équilibre", "Passerelle"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8029: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de l’épreuve où les candidats doivent assembler un puzzle ?",
    answers: ["Casse-tête", "Puzzle infernal", "Assemblage", "Énigme visuelle"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8030: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de l’épreuve où les candidats doivent sauter d’une plateforme ?",
    answers: ["Saut intérieur", "Plongeon", "Saut de l’ange", "Chute libre"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id8031: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Dans quelle mer se trouve le Fort Boyard ?",
    answers: ["Méditerranée", "Atlantique", "Manche", "Mer du Nord"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8032: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le surnom du fort ?",
    answers: ["Château d’Or", "Fort des Mers", "Vaisseau de Pierre", "Tour d’Acier"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id8033: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel était le rôle de La Boule dans l’émission ?",
    answers: ["Gardien des clés", "Gardien des prisonniers", "Gardien des Boyards", "Présentateur"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8034: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel personnage est apparu en 2011 pour juger les candidats ?",
    answers: ["Blanche", "Noire", "Rouge", "Verte"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8045: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel personnage est connu pour ses plats répugnants ?",
    answers: ["Willy Rovelli", "Père Fouras", "Félindra", "Passe-Muraille"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8046: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de la chaîne qui diffuse Fort Boyard en France ?",
    answers: ["TF1", "France 2", "M6", "Canal+"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8047: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de l’île voisine de Fort Boyard ?",
    answers: ["Île d’Oléron", "Île d’Aix", "Île de Ré", "Belle-Île"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8048: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de la salle où les candidats ont le choix entre deux défis ?",
    answers: ["Salle du Trésor", "Salle du Jugement", "Salle du Conseil", "Vigie"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8049: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom du producteur historique de Fort Boyard ?",
    answers: ["Nagui", "Jacques Antoine", "Alexia Laroche-Joubert", "Thierry Ardisson"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8050: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de la société qui produit Fort Boyard depuis 2006 ?",
    answers: ["Endemol", "Adventure Line Productions", "TF1 Production", "Banijay"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8051: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel personnage est associé à un fouet ?",
    answers: ["Félindra", "Père Fouras", "Blanche", "Willy Rovelli"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8052: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom du département où se trouve Fort Boyard ?",
    answers: ["Vendée", "Charente-Maritime", "Gironde", "Finistère"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8053: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nom de la première co-animatrice de l’émission ?",
    answers: ["Cendrine Dominguez", "Sophie Davant", "Valérie Payet", "Anne-Gaëlle Riccio"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8054: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le nombre de tigres dans la Salle du Trésor en 1990 ?",
    answers: ["2", "3", "4", "5"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id8055: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel animateur a co-présenté l’émission avec Anne-Gaëlle Riccio ?",
    answers: ["Jean-Pierre Castaldi", "Vincent Lagaf’", "Olivier Minne", "Laurent Broomhead"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id8056: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel est le vrai prénom de Passe-Partout ?",
    answers: ["André", "Alain", "Anthony", "Samuel"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id8057: {
    themes: ["Culture Pop", "Fort Boyard","Divers"],
    question: "Quel comédien a incarné le personnage de Ratman, maître des rats de 1992 à 1996 ?",
    answers: ["Guy DEMAZURE", "Dominique MACAIRE", "Willy ROVELLI", "Yann LE GAC"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15000: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Pacific Express (Union Pacific), réalisé par Cecil B. DeMille, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1951","1939","1949","1955"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15001: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Cecil B. DeMille, a remporté le Grand Prix du Festival international du film en 1939 ?",
    answers: ["Pacific Express","La Vie d’Adèle","L’Arbre aux sabots","La Loi du Seigneur"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15002: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1939 avec le film Pacific Express (Union Pacific) ?",
    answers: ["Cecil B. DeMille","Vittorio De Sica","Chen Kaige","Lindsay Anderson"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15003: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Pacific Express (Union Pacific), qui a remporté le Grand Prix du Festival international du film en 1939 ?",
    answers: ["Suède","France","Royaume-Uni/Italie","États-Unis"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15004: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le Poison (The Lost Weekend), réalisé par Billy Wilder, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1959","2003","1973","1946"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15005: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Billy Wilder, a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Brève rencontre","María Candelaria","Le Poison","Tourments"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15006: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1946 avec le film Le Poison (The Lost Weekend) ?",
    answers: ["Billy Wilder","David Lean","Alf Sjöberg","Elio Petri"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15007: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le Poison (The Lost Weekend), qui a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Suède","France","États-Unis","Suisse"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15008: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La terre sera rouge (De røde enge), réalisé par Bodil Ipsen et Lau Lauritzen Jr., a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1946","2001","1964","1965"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15009: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Bodil Ipsen et Lau Lauritzen Jr., a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["María Candelaria","La ville basse","Le Poison","La terre sera rouge"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15010: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1946 avec le film La terre sera rouge (De røde enge) ?",
    answers: ["Chetan Anand","Bodil Ipsen et Lau Lauritzen Jr.","Abdellatif Kechiche","Jean Delannoy"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15011: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La terre sera rouge (De røde enge), qui a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Royaume-Uni","Danemark","États-Unis","France"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15012: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année María Candelaria, réalisé par Emilio Fernández, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1962","1977","1946","1970"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15013: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Emilio Fernández, a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["María Candelaria","Le Poison","La terre sera rouge","Les Hommes sans ailes"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15014: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1946 avec le film María Candelaria ?",
    answers: ["Bodil Ipsen et Lau Lauritzen Jr.","Emilio Fernández","Jacques-Yves Cousteau et Louis Malle","David Lean"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15015: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient María Candelaria, qui a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Royaume-Uni/Italie","Mexique","Suède","Inde"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15016: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Rome, ville ouverte (Roma città aperta), réalisé par Roberto Rossellini, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1946","2007","1966","1964"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15017: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Roberto Rossellini, a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["La terre sera rouge","La Dernière Chance","Le Poison","Rome, ville ouverte"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15018: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1946 avec le film Rome, ville ouverte (Roma città aperta) ?",
    answers: ["Alf Sjöberg","Billy Wilder","Chetan Anand","Roberto Rossellini"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15019: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Rome, ville ouverte (Roma città aperta), qui a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Italie","États-Unis","Inde","Tchécoslovaquie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15020: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Brève rencontre (Brief Encounter), réalisé par David Lean, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1999","1947","1951","1946"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15021: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par David Lean, a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["La Dernière Chance","María Candelaria","Les Hommes sans ailes","Brève rencontre"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15022: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1946 avec le film Brève rencontre (Brief Encounter) ?",
    answers: ["Carol Reed","David Lean","Alf Sjöberg","Roberto Rossellini"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15023: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Brève rencontre (Brief Encounter), qui a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Belgique","France","Royaume-Uni","Suède"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15024: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Symphonie pastorale, réalisé par Jean Delannoy, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1954","1964","1952","1946"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15025: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Jean Delannoy, a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Rome, ville ouverte","La Symphonie pastorale","Brève rencontre","Le Troisième Homme"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15026: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1946 avec le film La Symphonie pastorale ?",
    answers: ["Bodil Ipsen et Lau Lauritzen Jr.","Jean Delannoy","Chetan Anand","Theo Angelopoulos"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15027: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Symphonie pastorale, qui a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["États-Unis","France","Mexique","Royaume-Uni"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15028: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Dernière Chance (Die letzte Chance), réalisé par Leopold Lindtberg, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1972","1951","1946","1957"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15029: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Leopold Lindtberg, a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["La terre sera rouge","La Dernière Chance","Miracle à Milan","Brève rencontre"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15030: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1946 avec le film La Dernière Chance (Die letzte Chance) ?",
    answers: ["Leopold Lindtberg","Emilio Fernández","Roberto Rossellini","Jacques Becker"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15031: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Dernière Chance (Die letzte Chance), qui a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Royaume-Uni","Suisse","États-Unis/Italie","Mexique"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15032: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Les Hommes sans ailes (Muži bez křídel), réalisé par František Čáp, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1957","1946","1990","1955"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15033: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par František Čáp, a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Rome, ville ouverte","Le messager","María Candelaria","Les Hommes sans ailes"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15034: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1946 avec le film Les Hommes sans ailes (Muži bez křídel) ?",
    answers: ["František Čáp","David Lean","Orson Welles","Jacques Becker"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15035: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Les Hommes sans ailes (Muži bez křídel), qui a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Suisse","Italie","France","Tchécoslovaquie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15036: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Tourments (Hets), réalisé par Alf Sjöberg, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1977","1946","1983","1951"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15037: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Alf Sjöberg, a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["La ville basse","Les Hommes sans ailes","La terre sera rouge","Tourments"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15038: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1946 avec le film Tourments (Hets) ?",
    answers: ["Emilio Fernández","Renato Castellani","Alf Sjöberg","David Lean"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15039: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Tourments (Hets), qui a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Suède","France","Suisse","Inde"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15040: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La ville basse (Neecha Nagar), réalisé par Chetan Anand, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1953","2000","1946","1952"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15041: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Chetan Anand, a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["La ville basse","María Candelaria","La Symphonie pastorale","Tourments"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15042: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1946 avec le film La ville basse (Neecha Nagar) ?",
    answers: ["Chetan Anand","Bodil Ipsen et Lau Lauritzen Jr.","Ben Sharpsteen","Vincente Minnelli"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15043: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La ville basse (Neecha Nagar), qui a remporté le Grand Prix du Festival international du film en 1946 ?",
    answers: ["Inde","États-Unis","Tchécoslovaquie","Suisse"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15044: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Ziegfeld Follies, réalisé par Vincente Minnelli, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1949","1951","1953","1947"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15045: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Vincente Minnelli, a remporté le Grand Prix du Festival international du film en 1947 ?",
    answers: ["La ville basse","Ziegfeld Follies","Dumbo","Le Poison"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15046: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1947 avec le film Ziegfeld Follies ?",
    answers: ["Vincente Minnelli","Luis Buñuel","Richard Lester","René Clément"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15047: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Ziegfeld Follies, qui a remporté le Grand Prix du Festival international du film en 1947 ?",
    answers: ["Tchécoslovaquie","États-Unis","France","Mexique"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15048: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Dumbo, réalisé par Ben Sharpsteen, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["2006","1947","1974","1978"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15049: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Ben Sharpsteen, a remporté le Grand Prix du Festival international du film en 1947 ?",
    answers: ["Antoine et Antoinette","Brève rencontre","Blow-Up","Dumbo"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15050: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1947 avec le film Dumbo ?",
    answers: ["Emilio Fernández","René Clément","Ben Sharpsteen","Jacques Becker"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15051: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Dumbo, qui a remporté le Grand Prix du Festival international du film en 1947 ?",
    answers: ["Suède","France","États-Unis","Royaume-Uni"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15052: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Les Maudits, réalisé par René Clément, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1946","1947","1953","1939"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15053: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par René Clément, a remporté le Grand Prix du Festival international du film en 1947 ?",
    answers: ["Les Maudits","Miracle à Milan","Brève rencontre","Antoine et Antoinette"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15054: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1947 avec le film Les Maudits ?",
    answers: ["René Clément","Jacques Becker","Ben Sharpsteen","Emir Kusturica"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15055: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Les Maudits, qui a remporté le Grand Prix du Festival international du film en 1947 ?",
    answers: ["Suède","France","Royaume-Uni","États-Unis"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15056: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Antoine et Antoinette, réalisé par Jacques Becker, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1947","1951","1949","1955"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15057: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Jacques Becker, a remporté le Grand Prix du Festival international du film en 1947 ?",
    answers: ["La terre sera rouge","L’Affaire Mattei","Les Maudits","Antoine et Antoinette"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15058: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1947 avec le film Antoine et Antoinette ?",
    answers: ["Emir Kusturica","Teinosuke Kinugasa","Jacques Becker","Ben Sharpsteen"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15059: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Antoine et Antoinette, qui a remporté le Grand Prix du Festival international du film en 1947 ?",
    answers: ["Italie","États-Unis","France","Suède"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15060: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le Troisième Homme (The Third Man), réalisé par Carol Reed, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1972","1970","1949","1997"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15061: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Carol Reed, a remporté le Grand Prix du Festival international du film en 1949 ?",
    answers: ["Le Guépard","María Candelaria","Orfeu Negro","Le Troisième Homme"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15062: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1949 avec le film Le Troisième Homme (The Third Man) ?",
    answers: ["Michelangelo Antonioni","Carol Reed","Jacques Demy","Vincente Minnelli"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15063: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le Troisième Homme (The Third Man), qui a remporté le Grand Prix du Festival international du film en 1949 ?",
    answers: ["Italie","Royaume-Uni","Suède","France"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15064: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Mademoiselle Julie (Fröken Julie), réalisé par Alf Sjöberg, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1957","1966","1994","1951"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15065: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Alf Sjöberg, a remporté le Grand Prix du Festival international du film en 1951 ?",
    answers: ["Miracle à Milan","Antoine et Antoinette","Le Goût de la cerise","Mademoiselle Julie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15066: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1951 avec le film Mademoiselle Julie (Fröken Julie) ?",
    answers: ["Vincente Minnelli","Alf Sjöberg","Vittorio De Sica","Jane Campion"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15067: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Mademoiselle Julie (Fröken Julie), qui a remporté le Grand Prix du Festival international du film en 1951 ?",
    answers: ["Suède","France","Italie","Japon"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15068: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Miracle à Milan (Miracolo a Milano), réalisé par Vittorio De Sica, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1951","1949","1952","2014"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15069: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Vittorio De Sica, a remporté le Grand Prix du Festival international du film en 1951 ?",
    answers: ["Le Monde du silence","Miracle à Milan","Missing : Porté disparu","La ville basse"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15070: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1951 avec le film Miracle à Milan (Miracolo a Milano) ?",
    answers: ["Teinosuke Kinugasa","Vittorio De Sica","Orson Welles","Alf Sjöberg"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15071: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Miracle à Milan (Miracolo a Milano), qui a remporté le Grand Prix du Festival international du film en 1951 ?",
    answers: ["Thaïlande","France","Italie","Suède"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15072: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Othello, réalisé par Orson Welles, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1973","1961","1982","1952"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15073: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Orson Welles, a remporté le Grand Prix du Festival international du film en 1952 ?",
    answers: ["Mademoiselle Julie","La ville basse","Le Pianiste","Othello"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15074: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1952 avec le film Othello ?",
    answers: ["Orson Welles","Carol Reed","Terrence Malick","René Clément"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15075: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Othello, qui a remporté le Grand Prix du Festival international du film en 1952 ?",
    answers: ["Italie","Danemark","Suède","États-Unis/Italie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15076: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Deux sous d’espoir (Due soldi di speranza), réalisé par Renato Castellani, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1954","1952","1953","1956"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15077: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Renato Castellani, a remporté le Grand Prix du Festival international du film en 1952 ?",
    answers: ["La ville basse","Deux sous d’espoir","Miracle à Milan","La Parole donnée"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15078: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1952 avec le film Deux sous d’espoir (Due soldi di speranza) ?",
    answers: ["Orson Welles","Alf Sjöberg","Renato Castellani","Jacques Demy"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15079: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Deux sous d’espoir (Due soldi di speranza), qui a remporté le Grand Prix du Festival international du film en 1952 ?",
    answers: ["France","Italie","Royaume-Uni","Autriche/France"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15080: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le Salaire de la peur, réalisé par Henri-Georges Clouzot, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1970","1954","1953","1955"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15081: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Henri-Georges Clouzot, a remporté le Grand Prix du Festival international du film en 1953 ?",
    answers: ["Le Tambour","Le Salaire de la peur","La Dernière Chance","Marty"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15082: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1953 avec le film Le Salaire de la peur ?",
    answers: ["William Wyler","Shōhei Imamura","Henri-Georges Clouzot","Richard Lester"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15083: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le Salaire de la peur, qui a remporté le Grand Prix du Festival international du film en 1953 ?",
    answers: ["États-Unis/Italie","Royaume-Uni","États-Unis","France"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15084: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Porte de l’enfer (Jigokumon), réalisé par Teinosuke Kinugasa, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1969","1954","1992","1984"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15085: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Teinosuke Kinugasa, a remporté le Grand Prix du Festival international du film en 1954 ?",
    answers: ["Othello","Deux sous d’espoir","La Porte de l’enfer","La Loi du Seigneur"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15086: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1954 avec le film La Porte de l’enfer (Jigokumon) ?",
    answers: ["Vittorio De Sica","Teinosuke Kinugasa","Renato Castellani","Bodil Ipsen et Lau Lauritzen Jr."],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15087: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Porte de l’enfer (Jigokumon), qui a remporté le Grand Prix du Festival international du film en 1954 ?",
    answers: ["Royaume-Uni","Suisse","Japon","France"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15088: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Marty, réalisé par Delbert Mann, a-t-il remporté la Palme d’Or ?",
    answers: ["1983","1955","2019","1961"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15089: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Delbert Mann, a remporté la Palme d’Or en 1955 ?",
    answers: ["Mademoiselle Julie","Deux sous d’espoir","La Porte de l’enfer","Marty"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15090: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1955 avec le film Marty ?",
    answers: ["René Clément","Renato Castellani","William Wyler","Delbert Mann"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15091: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Marty, qui a remporté la Palme d’Or en 1955 ?",
    answers: ["France","États-Unis","Italie","Algérie"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15092: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le Monde du silence, réalisé par Jacques-Yves Cousteau et Louis Malle, a-t-il remporté la Palme d’Or ?",
    answers: ["1957","1956","1949","1960"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15093: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Jacques-Yves Cousteau et Louis Malle, a remporté la Palme d’Or en 1956 ?",
    answers: ["Ces messieurs dames","Le Monde du silence","Marty","Deux sous d’espoir"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15094: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1956 avec le film Le Monde du silence ?",
    answers: ["Michelangelo Antonioni","Jacques-Yves Cousteau et Louis Malle","Volker Schlöndorff","Mike Leigh"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15095: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le Monde du silence, qui a remporté la Palme d’Or en 1956 ?",
    answers: ["Japon","Italie","États-Unis","France"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15096: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Loi du Seigneur (Friendly Persuasion), réalisé par William Wyler, a-t-il remporté la Palme d’Or ?",
    answers: ["1962","1987","1957","1955"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15097: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par William Wyler, a remporté la Palme d’Or en 1957 ?",
    answers: ["Un homme et une femme","Deux sous d’espoir","Le Knack… et comment l’avoir","La Loi du Seigneur"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15098: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1957 avec le film La Loi du Seigneur (Friendly Persuasion) ?",
    answers: ["Teinosuke Kinugasa","Robert Altman","William Wyler","Joel & Ethan Coen"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15099: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Loi du Seigneur (Friendly Persuasion), qui a remporté la Palme d’Or en 1957 ?",
    answers: ["États-Unis/Italie","France","États-Unis","Italie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15100: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Quand passent les cigognes (Letyat zhuravli), réalisé par Mikhail Kalatozov, a-t-il remporté la Palme d’Or ?",
    answers: ["1958","1984","1939","1959"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15101: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Mikhail Kalatozov, a remporté la Palme d’Or en 1958 ?",
    answers: ["Ziegfeld Follies","Quand passent les cigognes","Le Goût de la cerise","Dumbo"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15102: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1958 avec le film Quand passent les cigognes (Letyat zhuravli) ?",
    answers: ["William Wyler","Bodil Ipsen et Lau Lauritzen Jr.","Mikhail Kalatozov","Mohammed Lakhdar-Hamina"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15103: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Quand passent les cigognes (Letyat zhuravli), qui a remporté la Palme d’Or en 1958 ?",
    answers: ["France","Union soviétique","Suède","États-Unis"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15104: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Orfeu Negro, réalisé par Marcel Camus, a-t-il remporté la Palme d’Or ?",
    answers: ["1959","1960","2011","1958"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15105: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Marcel Camus, a remporté la Palme d’Or en 1959 ?",
    answers: ["La ville basse","Titane","Orfeu Negro","Quand passent les cigognes"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15106: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1959 avec le film Orfeu Negro ?",
    answers: ["Michelangelo Antonioni","Marcel Camus","Bille August","Renato Castellani"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15107: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Orfeu Negro, qui a remporté la Palme d’Or en 1959 ?",
    answers: ["Suisse","Union soviétique","États-Unis","France"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15108: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Dolce Vita, réalisé par Federico Fellini, a-t-il remporté la Palme d’Or ?",
    answers: ["1949","1956","2017","1960"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15109: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Federico Fellini, a remporté la Palme d’Or en 1960 ?",
    answers: ["La Loi du Seigneur","La Dolce Vita","Le Goût de la cerise","Le Monde du silence"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15110: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1960 avec le film La Dolce Vita ?",
    answers: ["Marcel Camus","Luchino Visconti","Mikhail Kalatozov","Federico Fellini"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15111: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Dolce Vita, qui a remporté la Palme d’Or en 1960 ?",
    answers: ["Italie","France","Japon","États-Unis"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15112: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Une aussi longue absence, réalisé par Henri Colpi, a-t-il remporté la Palme d’Or ?",
    answers: ["1959","1975","1963","1961"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15113: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Henri Colpi, a remporté la Palme d’Or en 1961 ?",
    answers: ["Fahrenheit 9/11","Titane","Une aussi longue absence","Les Parapluies de Cherbourg"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15114: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1961 avec le film Une aussi longue absence ?",
    answers: ["Luis Buñuel","Henri Colpi","Robert Altman","Delbert Mann"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15115: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Une aussi longue absence, qui a remporté la Palme d’Or en 1961 ?",
    answers: ["Union soviétique","Japon","États-Unis","France"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15116: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Viridiana, réalisé par Luis Buñuel, a-t-il remporté la Palme d’Or ?",
    answers: ["1978","1956","2000","1961"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15117: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Luis Buñuel, a remporté la Palme d’Or en 1961 ?",
    answers: ["Une aussi longue absence","Viridiana","Rome, ville ouverte","Pacific Express"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15118: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1961 avec le film Viridiana ?",
    answers: ["Luis Buñuel","Akira Kurosawa","Mikhail Kalatozov","Anselmo Duarte"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15119: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Viridiana, qui a remporté la Palme d’Or en 1961 ?",
    answers: ["Brésil","Italie","Espagne/Mexique","France"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15120: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Parole donnée (O Pagador de Promessas), réalisé par Anselmo Duarte, a-t-il remporté la Palme d’Or ?",
    answers: ["1962","1965","1946","1951"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15121: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Anselmo Duarte, a remporté la Palme d’Or en 1962 ?",
    answers: ["Une aussi longue absence","La Classe ouvrière va au paradis","La Parole donnée","MASH"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15122: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1962 avec le film La Parole donnée (O Pagador de Promessas) ?",
    answers: ["Luchino Visconti","Akira Kurosawa","Richard Lester","Anselmo Duarte"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15123: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Parole donnée (O Pagador de Promessas), qui a remporté la Palme d’Or en 1962 ?",
    answers: ["Italie","Algérie","Brésil","Royaume-Uni/Italie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15124: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le Guépard (Il Gattopardo), réalisé par Luchino Visconti, a-t-il remporté la Palme d’Or ?",
    answers: ["1988","1957","1967","1963"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15125: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Luchino Visconti, a remporté la Palme d’Or en 1963 ?",
    answers: ["La Parole donnée","Dumbo","Le Guépard","Conversation secrète"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15126: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1963 avec le film Le Guépard (Il Gattopardo) ?",
    answers: ["David Lean","Pietro Germi","Alan Bridges","Luchino Visconti"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15127: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le Guépard (Il Gattopardo), qui a remporté la Palme d’Or en 1963 ?",
    answers: ["Italie","France","Brésil","Japon"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15128: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Les Parapluies de Cherbourg, réalisé par Jacques Demy, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1964","1966","1982","1973"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15129: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Jacques Demy, a remporté le Grand Prix du Festival international du film en 1964 ?",
    answers: ["Un homme et une femme","Le Poison","Sailor et Lula","Les Parapluies de Cherbourg"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15130: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1964 avec le film Les Parapluies de Cherbourg ?",
    answers: ["Luchino Visconti","Anselmo Duarte","Orson Welles","Jacques Demy"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15131: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Les Parapluies de Cherbourg, qui a remporté le Grand Prix du Festival international du film en 1964 ?",
    answers: ["Royaume-Uni","Brésil","Italie","France"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15132: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le Knack… et comment l’avoir (The Knack …and How to Get It), réalisé par Richard Lester, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1969","1965","1946","1960"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15133: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Richard Lester, a remporté le Grand Prix du Festival international du film en 1965 ?",
    answers: ["Quand passent les cigognes","Le Knack… et comment l’avoir","Un homme et une femme","If…"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15134: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1965 avec le film Le Knack… et comment l’avoir (The Knack …and How to Get It) ?",
    answers: ["Wim Wenders","Richard Lester","Robert Altman","Luchino Visconti"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15135: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le Knack… et comment l’avoir (The Knack …and How to Get It), qui a remporté le Grand Prix du Festival international du film en 1965 ?",
    answers: ["Royaume-Uni","États-Unis","France","Italie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15136: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Un homme et une femme, réalisé par Claude Lelouch, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1966","1990","1989","1964"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15137: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Claude Lelouch, a remporté le Grand Prix du Festival international du film en 1966 ?",
    answers: ["Un homme et une femme","Taxi Driver","La Parole donnée","Blow-Up"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15138: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1966 avec le film Un homme et une femme ?",
    answers: ["Ermanno Olmi","Michelangelo Antonioni","Claude Lelouch","Alan Bridges"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15139: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Un homme et une femme, qui a remporté le Grand Prix du Festival international du film en 1966 ?",
    answers: ["France","Royaume-Uni/Italie","Royaume-Uni","Italie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15140: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Ces messieurs dames (Signore & Signori), réalisé par Pietro Germi, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1989","2008","1961","1966"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15141: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Pietro Germi, a remporté le Grand Prix du Festival international du film en 1966 ?",
    answers: ["Ces messieurs dames","Sous le soleil de Satan","Le Troisième Homme","Un homme et une femme"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15142: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1966 avec le film Ces messieurs dames (Signore & Signori) ?",
    answers: ["Richard Lester","Pietro Germi","Luis Buñuel","Anselmo Duarte"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15143: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Ces messieurs dames (Signore & Signori), qui a remporté le Grand Prix du Festival international du film en 1966 ?",
    answers: ["Brésil","Suède","France","Italie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15144: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Blow-Up, réalisé par Michelangelo Antonioni, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1951","1963","1966","1967"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15145: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Michelangelo Antonioni, a remporté le Grand Prix du Festival international du film en 1967 ?",
    answers: ["L’Arbre aux sabots","Blow-Up","If…","Ces messieurs dames"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15146: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1967 avec le film Blow-Up ?",
    answers: ["Emir Kusturica","Lindsay Anderson","Shōhei Imamura","Michelangelo Antonioni"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15147: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Blow-Up, qui a remporté le Grand Prix du Festival international du film en 1967 ?",
    answers: ["Royaume-Uni/Italie","Danemark","États-Unis","Italie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15148: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année If…, réalisé par Lindsay Anderson, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1979","1969","2000","1967"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15149: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Lindsay Anderson, a remporté le Grand Prix du Festival international du film en 1969 ?",
    answers: ["La Méprise","If…","Les Parapluies de Cherbourg","Le Salaire de la peur"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15150: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1969 avec le film If… ?",
    answers: ["Alan Bridges","Lindsay Anderson","Robert Altman","Ermanno Olmi"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15151: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient If…, qui a remporté le Grand Prix du Festival international du film en 1969 ?",
    answers: ["Royaume-Uni","France","États-Unis","Royaume-Uni/Italie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15152: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année MASH, réalisé par Robert Altman, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1980","1970","1997","1967"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15153: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Robert Altman, a remporté le Grand Prix du Festival international du film en 1970 ?",
    answers: ["MASH","Yol, la permission","Tourments","Le Guépard"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15154: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1970 avec le film MASH ?",
    answers: ["Francis Ford Coppola","Pietro Germi","Robert Altman","Jerry Schatzberg"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15155: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient MASH, qui a remporté le Grand Prix du Festival international du film en 1970 ?",
    answers: ["États-Unis","France","Italie","Belgique"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15156: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le messager (The Go-Between), réalisé par Joseph Losey, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1962","1972","1969","1971"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15157: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Joseph Losey, a remporté le Grand Prix du Festival international du film en 1971 ?",
    answers: ["Miracle à Milan","Chronique des années de braise","Yol, la permission","Le messager"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15158: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1971 avec le film Le messager (The Go-Between) ?",
    answers: ["Joseph Losey","Paolo & Vittorio Taviani","Claude Lelouch","Robert Altman"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15159: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le messager (The Go-Between), qui a remporté le Grand Prix du Festival international du film en 1971 ?",
    answers: ["Italie","Danemark/Suède","Royaume-Uni","États-Unis"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15160: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Classe ouvrière va au paradis (La classe operaia va in paradiso), réalisé par Elio Petri, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1980","1972","1999","1973"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15161: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Elio Petri, a remporté le Grand Prix du Festival international du film en 1972 ?",
    answers: ["La Classe ouvrière va au paradis","Une aussi longue absence","L’Anguille","Viridiana"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15162: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1972 avec le film La Classe ouvrière va au paradis (La classe operaia va in paradiso) ?",
    answers: ["Elio Petri","Jean-Pierre & Luc Dardenne","Joseph Losey","Francesco Rosi"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15163: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Classe ouvrière va au paradis (La classe operaia va in paradiso), qui a remporté le Grand Prix du Festival international du film en 1972 ?",
    answers: ["Turquie","France","Japon","Italie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15164: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année L’Affaire Mattei (Il caso Mattei), réalisé par Francesco Rosi, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1955","1971","1972","1989"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15165: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Francesco Rosi, a remporté le Grand Prix du Festival international du film en 1972 ?",
    answers: ["La Classe ouvrière va au paradis","L’Affaire Mattei","Antoine et Antoinette","L’Épouvantail"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15166: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1972 avec le film L’Affaire Mattei (Il caso Mattei) ?",
    answers: ["Alan Bridges","Francesco Rosi","Apichatpong Weerasethakul","Joseph Losey"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15167: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient L’Affaire Mattei (Il caso Mattei), qui a remporté le Grand Prix du Festival international du film en 1972 ?",
    answers: ["Italie","États-Unis","Yougoslavie","Royaume-Uni"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15168: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Méprise (The Hireling), réalisé par Alan Bridges, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1973","1974","1967","1971"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15169: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Alan Bridges, a remporté le Grand Prix du Festival international du film en 1973 ?",
    answers: ["L’Épouvantail","La Méprise","Taxi Driver","Adieu ma concubine"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15170: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1973 avec le film La Méprise (The Hireling) ?",
    answers: ["Mohammed Lakhdar-Hamina","Paolo & Vittorio Taviani","Francesco Rosi","Alan Bridges"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15171: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Méprise (The Hireling), qui a remporté le Grand Prix du Festival international du film en 1973 ?",
    answers: ["Royaume-Uni","Algérie","États-Unis","Chine"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15172: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année L’Épouvantail (Scarecrow), réalisé par Jerry Schatzberg, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1972","1973","1974","1991"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15173: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Jerry Schatzberg, a remporté le Grand Prix du Festival international du film en 1973 ?",
    answers: ["Adieu ma concubine","L’Affaire Mattei","L’Épouvantail","La Méprise"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15174: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1973 avec le film L’Épouvantail (Scarecrow) ?",
    answers: ["Joseph Losey","Alan Bridges","Jerry Schatzberg","Francis Ford Coppola"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15175: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient L’Épouvantail (Scarecrow), qui a remporté le Grand Prix du Festival international du film en 1973 ?",
    answers: ["États-Unis","Italie","Royaume-Uni","Espagne/Mexique"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15176: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Conversation secrète (The Conversation), réalisé par Francis Ford Coppola, a-t-il remporté le Grand Prix du Festival international du film ?",
    answers: ["1984","1974","1985","1971"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15177: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Francis Ford Coppola, a remporté le Grand Prix du Festival international du film en 1974 ?",
    answers: ["MASH","L’Épouvantail","Conversation secrète","La Chambre du fils"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15178: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté le Grand Prix du Festival international du film en 1974 avec le film Conversation secrète (The Conversation) ?",
    answers: ["Francesco Rosi","Martin Scorsese","Francis Ford Coppola","Volker Schlöndorff"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15179: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Conversation secrète (The Conversation), qui a remporté le Grand Prix du Festival international du film en 1974 ?",
    answers: ["Royaume-Uni","États-Unis","Japon","Algérie"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15180: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Chronique des années de braise (Waqa'i' sanawat ed-djamr), réalisé par Mohammed Lakhdar-Hamina, a-t-il remporté la Palme d’Or ?",
    answers: ["1975","1983","1976","1993"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15181: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Mohammed Lakhdar-Hamina, a remporté la Palme d’Or en 1975 ?",
    answers: ["Sous le soleil de Satan","Chronique des années de braise","La Classe ouvrière va au paradis","Conversation secrète"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15182: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1975 avec le film Chronique des années de braise (Waqa'i' sanawat ed-djamr) ?",
    answers: ["Francis Ford Coppola","Chetan Anand","Mohammed Lakhdar-Hamina","Maurice Pialat"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15183: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Chronique des années de braise (Waqa'i' sanawat ed-djamr), qui a remporté la Palme d’Or en 1975 ?",
    answers: ["Royaume-Uni","Algérie","Italie","Iran"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15184: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Taxi Driver, réalisé par Martin Scorsese, a-t-il remporté la Palme d’Or ?",
    answers: ["1976","1987","1973","1980"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15185: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Martin Scorsese, a remporté la Palme d’Or en 1976 ?",
    answers: ["Taxi Driver","L’Arbre aux sabots","Padre Padrone","Le Tambour"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15186: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1976 avec le film Taxi Driver ?",
    answers: ["Elio Petri","Yılmaz Güney","Martin Scorsese","Alan Bridges"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15187: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Taxi Driver, qui a remporté la Palme d’Or en 1976 ?",
    answers: ["États-Unis","Algérie","France","Royaume-Uni"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15188: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Padre Padrone, réalisé par Paolo & Vittorio Taviani, a-t-il remporté la Palme d’Or ?",
    answers: ["1975","1977","1976","2005"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15189: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Paolo & Vittorio Taviani, a remporté la Palme d’Or en 1977 ?",
    answers: ["Un homme et une femme","Mademoiselle Julie","Yol, la permission","Padre Padrone"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15190: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1977 avec le film Padre Padrone ?",
    answers: ["Akira Kurosawa","Richard Lester","Jerry Schatzberg","Paolo & Vittorio Taviani"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15191: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Padre Padrone, qui a remporté la Palme d’Or en 1977 ?",
    answers: ["Allemagne/États-Unis","États-Unis/Grèce","Italie","Japon"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15192: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année L’Arbre aux sabots (L’albero degli zoccoli), réalisé par Ermanno Olmi, a-t-il remporté la Palme d’Or ?",
    answers: ["1974","1977","1978","1987"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15193: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Ermanno Olmi, a remporté la Palme d’Or en 1978 ?",
    answers: ["Secrets et mensonges","L’Arbre aux sabots","Dumbo","Kagemusha, l’ombre du guerrier"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15194: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1978 avec le film L’Arbre aux sabots (L’albero degli zoccoli) ?",
    answers: ["Andrzej Wajda","Costa-Gavras","Federico Fellini","Ermanno Olmi"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15195: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient L’Arbre aux sabots (L’albero degli zoccoli), qui a remporté la Palme d’Or en 1978 ?",
    answers: ["Japon","Yougoslavie","Italie","Royaume-Uni"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15196: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Apocalypse Now, réalisé par Francis Ford Coppola, a-t-il remporté la Palme d’Or ?",
    answers: ["1957","1983","1980","1979"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15197: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Francis Ford Coppola, a remporté la Palme d’Or en 1979 ?",
    answers: ["Apocalypse Now","Un homme et une femme","Yol, la permission","Barton Fink"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15198: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1979 avec le film Apocalypse Now ?",
    answers: ["Francis Ford Coppola","Paolo & Vittorio Taviani","Marcel Camus","Volker Schlöndorff"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15199: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Apocalypse Now, qui a remporté la Palme d’Or en 1979 ?",
    answers: ["Italie","Allemagne","États-Unis","Turquie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15200: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le Tambour (Die Blechtrommel), réalisé par Volker Schlöndorff, a-t-il remporté la Palme d’Or ?",
    answers: ["1971","1977","1979","1976"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15201: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Volker Schlöndorff, a remporté la Palme d’Or en 1979 ?",
    answers: ["Apocalypse Now","Padre Padrone","L’Arbre aux sabots","Le Tambour"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15202: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1979 avec le film Le Tambour (Die Blechtrommel) ?",
    answers: ["Yılmaz Güney","Bob Fosse","Emir Kusturica","Volker Schlöndorff"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15203: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le Tambour (Die Blechtrommel), qui a remporté la Palme d’Or en 1979 ?",
    answers: ["Italie","Mexique","Allemagne","Royaume-Uni"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15204: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Que le spectacle commence (All That Jazz), réalisé par Bob Fosse, a-t-il remporté la Palme d’Or ?",
    answers: ["1972","1982","1980","1977"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15205: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Bob Fosse, a remporté la Palme d’Or en 1980 ?",
    answers: ["Pelle le Conquérant","L’Homme de fer","Que le spectacle commence","Kagemusha, l’ombre du guerrier"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15206: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1980 avec le film Que le spectacle commence (All That Jazz) ?",
    answers: ["Bob Fosse","Andrzej Wajda","Paolo & Vittorio Taviani","Akira Kurosawa"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15207: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Que le spectacle commence (All That Jazz), qui a remporté la Palme d’Or en 1980 ?",
    answers: ["Turquie","Pologne","Italie","États-Unis"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15208: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Kagemusha, l’ombre du guerrier (Kagemusha), réalisé par Akira Kurosawa, a-t-il remporté la Palme d’Or ?",
    answers: ["1979","1980","1963","1982"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15209: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Akira Kurosawa, a remporté la Palme d’Or en 1980 ?",
    answers: ["Pulp Fiction","Underground","Padre Padrone","Kagemusha, l’ombre du guerrier"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15210: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1980 avec le film Kagemusha, l’ombre du guerrier (Kagemusha) ?",
    answers: ["Bob Fosse","Alan Bridges","Akira Kurosawa","David Lynch"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15211: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Kagemusha, l’ombre du guerrier (Kagemusha), qui a remporté la Palme d’Or en 1980 ?",
    answers: ["Japon","Nouvelle-Zélande/Australie","États-Unis","Italie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15212: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année L’Homme de fer (Człowiek z żelaza), réalisé par Andrzej Wajda, a-t-il remporté la Palme d’Or ?",
    answers: ["1982","1979","1975","1981"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15213: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Andrzej Wajda, a remporté la Palme d’Or en 1981 ?",
    answers: ["Paris, Texas","Le Poison","Orfeu Negro","L’Homme de fer"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15214: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1981 avec le film L’Homme de fer (Człowiek z żelaza) ?",
    answers: ["Teinosuke Kinugasa","Costa-Gavras","Andrzej Wajda","Terrence Malick"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15215: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient L’Homme de fer (Człowiek z żelaza), qui a remporté la Palme d’Or en 1981 ?",
    answers: ["Pologne","Autriche/Allemagne","États-Unis","France"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15216: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Missing : Porté disparu (Missing), réalisé par Costa-Gavras, a-t-il remporté la Palme d’Or ?",
    answers: ["1970","2005","1958","1982"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15217: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Costa-Gavras, a remporté la Palme d’Or en 1982 ?",
    answers: ["Yol, la permission","La Chambre du fils","Conversation secrète","Missing : Porté disparu"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15218: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1982 avec le film Missing : Porté disparu (Missing) ?",
    answers: ["Bob Fosse","Akira Kurosawa","Francis Ford Coppola","Costa-Gavras"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15219: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Missing : Porté disparu (Missing), qui a remporté la Palme d’Or en 1982 ?",
    answers: ["Nouvelle-Zélande/Australie","États-Unis/Grèce","Brésil","Japon"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15220: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Yol, la permission (Yol), réalisé par Yılmaz Güney, a-t-il remporté la Palme d’Or ?",
    answers: ["1978","1983","1982","1986"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15221: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Yılmaz Güney, a remporté la Palme d’Or en 1982 ?",
    answers: ["Le Tambour","Chronique des années de braise","Dheepan","Yol, la permission"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15222: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1982 avec le film Yol, la permission (Yol) ?",
    answers: ["Yılmaz Güney","Wim Wenders","Roland Joffé","Abdellatif Kechiche"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15223: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Yol, la permission (Yol), qui a remporté la Palme d’Or en 1982 ?",
    answers: ["Italie","États-Unis","Yougoslavie","Turquie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15224: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Ballade de Narayama (Narayama bushikō), réalisé par Shōhei Imamura, a-t-il remporté la Palme d’Or ?",
    answers: ["1960","1978","1979","1983"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15225: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Shōhei Imamura, a remporté la Palme d’Or en 1983 ?",
    answers: ["Sailor et Lula","Conversation secrète","La Ballade de Narayama","Amour"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15226: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1983 avec le film La Ballade de Narayama (Narayama bushikō) ?",
    answers: ["Shōhei Imamura","Costa-Gavras","Andrzej Wajda","Jane Campion"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15227: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Ballade de Narayama (Narayama bushikō), qui a remporté la Palme d’Or en 1983 ?",
    answers: ["Japon","Chine","États-Unis","Royaume-Uni"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15228: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Paris, Texas, réalisé par Wim Wenders, a-t-il remporté la Palme d’Or ?",
    answers: ["1987","1984","1983","1988"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15229: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Wim Wenders, a remporté la Palme d’Or en 1984 ?",
    answers: ["MASH","Mission","Paris, Texas","La Ballade de Narayama"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15230: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1984 avec le film Paris, Texas ?",
    answers: ["Roland Joffé","Emir Kusturica","Volker Schlöndorff","Wim Wenders"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15231: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Paris, Texas, qui a remporté la Palme d’Or en 1984 ?",
    answers: ["Turquie","Italie","Royaume-Uni","Allemagne/États-Unis"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15232: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Papa est en voyage d’affaires (Otac na službenom putu), réalisé par Emir Kusturica, a-t-il remporté la Palme d’Or ?",
    answers: ["1981","1994","1982","1985"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15233: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Emir Kusturica, a remporté la Palme d’Or en 1985 ?",
    answers: ["Yol, la permission","Papa est en voyage d’affaires","Kagemusha, l’ombre du guerrier","Paris, Texas"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15234: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1985 avec le film Papa est en voyage d’affaires (Otac na službenom putu) ?",
    answers: ["Francesco Rosi","Emir Kusturica","Paolo & Vittorio Taviani","Jean-Pierre & Luc Dardenne"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15235: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Papa est en voyage d’affaires (Otac na službenom putu), qui a remporté la Palme d’Or en 1985 ?",
    answers: ["Yougoslavie","Danemark/Suède","États-Unis","Royaume-Uni"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15236: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Mission (The Mission), réalisé par Roland Joffé, a-t-il remporté la Palme d’Or ?",
    answers: ["1978","1986","1983","1973"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15237: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Roland Joffé, a remporté la Palme d’Or en 1986 ?",
    answers: ["La Ballade de Narayama","Pelle le Conquérant","Mission","Papa est en voyage d’affaires"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15238: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1986 avec le film Mission (The Mission) ?",
    answers: ["Maurice Pialat","Roland Joffé","Abdellatif Kechiche","Wim Wenders"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15239: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Mission (The Mission), qui a remporté la Palme d’Or en 1986 ?",
    answers: ["Allemagne/États-Unis","États-Unis","Royaume-Uni","Algérie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15240: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Sous le soleil de Satan, réalisé par Maurice Pialat, a-t-il remporté la Palme d’Or ?",
    answers: ["1986","2017","1987","2024"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15241: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Maurice Pialat, a remporté la Palme d’Or en 1987 ?",
    answers: ["Le Monde du silence","L’Homme de fer","Sous le soleil de Satan","Barton Fink"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15242: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1987 avec le film Sous le soleil de Satan ?",
    answers: ["Maurice Pialat","Bob Fosse","Steven Soderbergh","Roland Joffé"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15243: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Sous le soleil de Satan, qui a remporté la Palme d’Or en 1987 ?",
    answers: ["États-Unis","Belgique","France","Royaume-Uni"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15244: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Pelle le Conquérant (Pelle Erobreren), réalisé par Bille August, a-t-il remporté la Palme d’Or ?",
    answers: ["1983","1988","1972","1990"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15245: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Bille August, a remporté la Palme d’Or en 1988 ?",
    answers: ["Sailor et Lula","Sexe, mensonges et vidéo","Pelle le Conquérant","Sous le soleil de Satan"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15246: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1988 avec le film Pelle le Conquérant (Pelle Erobreren) ?",
    answers: ["Bille August","Theo Angelopoulos","Roland Joffé","Ruben Östlund"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15247: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Pelle le Conquérant (Pelle Erobreren), qui a remporté la Palme d’Or en 1988 ?",
    answers: ["Mexique","Danemark/Suède","Yougoslavie","Iran"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15248: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Sexe, mensonges et vidéo (Sex, Lies, and Videotape), réalisé par Steven Soderbergh, a-t-il remporté la Palme d’Or ?",
    answers: ["1989","1990","1993","1995"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15249: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Steven Soderbergh, a remporté la Palme d’Or en 1989 ?",
    answers: ["L'Éternité et un jour","L’Anguille","The Square","Sexe, mensonges et vidéo"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15250: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1989 avec le film Sexe, mensonges et vidéo (Sex, Lies, and Videotape) ?",
    answers: ["Joel & Ethan Coen","Steven Soderbergh","Bille August","Paolo & Vittorio Taviani"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15251: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Sexe, mensonges et vidéo (Sex, Lies, and Videotape), qui a remporté la Palme d’Or en 1989 ?",
    answers: ["Danemark/Suède","Japon","Grèce","États-Unis"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15252: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Sailor et Lula (Wild at Heart), réalisé par David Lynch, a-t-il remporté la Palme d’Or ?",
    answers: ["1987","1990","1978","2017"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15253: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par David Lynch, a remporté la Palme d’Or en 1990 ?",
    answers: ["Sailor et Lula","Les Meilleures Intentions","Padre Padrone","La Ballade de Narayama"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15254: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1990 avec le film Sailor et Lula (Wild at Heart) ?",
    answers: ["Jerry Schatzberg","Terrence Malick","David Lynch","Emir Kusturica"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15255: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Sailor et Lula (Wild at Heart), qui a remporté la Palme d’Or en 1990 ?",
    answers: ["États-Unis","Union soviétique","Danemark/Suède","Roumanie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15256: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Barton Fink, réalisé par Joel & Ethan Coen, a-t-il remporté la Palme d’Or ?",
    answers: ["1992","2023","1990","1991"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15257: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Joel & Ethan Coen, a remporté la Palme d’Or en 1991 ?",
    answers: ["Adieu ma concubine","Padre Padrone","La Chambre du fils","Barton Fink"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15258: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1991 avec le film Barton Fink ?",
    answers: ["Andrzej Wajda","Quentin Tarantino","Joel & Ethan Coen","Shōhei Imamura"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15259: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Barton Fink, qui a remporté la Palme d’Or en 1991 ?",
    answers: ["États-Unis","Yougoslavie","France","Japon"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15260: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Les Meilleures Intentions (Den goda viljan), réalisé par Bille August, a-t-il remporté la Palme d’Or ?",
    answers: ["1987","2021","1992","1971"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15261: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Bille August, a remporté la Palme d’Or en 1992 ?",
    answers: ["Les Meilleures Intentions","Sexe, mensonges et vidéo","Le Guépard","Anora"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15262: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1992 avec le film Les Meilleures Intentions (Den goda viljan) ?",
    answers: ["David Lynch","Maurice Pialat","Chen Kaige","Bille August"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15263: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Les Meilleures Intentions (Den goda viljan), qui a remporté la Palme d’Or en 1992 ?",
    answers: ["Suède","États-Unis","Royaume-Uni","Yougoslavie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15264: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Adieu ma concubine (Bàwáng Bié Jī), réalisé par Chen Kaige, a-t-il remporté la Palme d’Or ?",
    answers: ["1984","1993","1992","1970"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15265: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Chen Kaige, a remporté la Palme d’Or en 1993 ?",
    answers: ["La Leçon de piano","Anatomie d’une chute","Adieu ma concubine","La Dolce Vita"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15266: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1993 avec le film Adieu ma concubine (Bàwáng Bié Jī) ?",
    answers: ["Anselmo Duarte","Mike Leigh","Chen Kaige","Jane Campion"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15267: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Adieu ma concubine (Bàwáng Bié Jī), qui a remporté la Palme d’Or en 1993 ?",
    answers: ["Suède","États-Unis","Belgique","Chine"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15268: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Leçon de piano (The Piano), réalisé par Jane Campion, a-t-il remporté la Palme d’Or ?",
    answers: ["1992","1989","1993","1997"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15269: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Jane Campion, a remporté la Palme d’Or en 1993 ?",
    answers: ["Underground","La Leçon de piano","Pelle le Conquérant","L'Éternité et un jour"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15270: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1993 avec le film La Leçon de piano (The Piano) ?",
    answers: ["Bodil Ipsen et Lau Lauritzen Jr.","Mohammed Lakhdar-Hamina","Jane Campion","Quentin Tarantino"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15271: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Leçon de piano (The Piano), qui a remporté la Palme d’Or en 1993 ?",
    answers: ["Nouvelle-Zélande/Australie","Chine","Pologne/France","Yougoslavie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15272: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Pulp Fiction, réalisé par Quentin Tarantino, a-t-il remporté la Palme d’Or ?",
    answers: ["2023","1994","1996","1992"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15273: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Quentin Tarantino, a remporté la Palme d’Or en 1994 ?",
    answers: ["Paris, Texas","Le Ruban blanc","La Dernière Chance","Pulp Fiction"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15274: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1994 avec le film Pulp Fiction ?",
    answers: ["Bille August","Joel & Ethan Coen","Orson Welles","Quentin Tarantino"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15275: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Pulp Fiction, qui a remporté la Palme d’Or en 1994 ?",
    answers: ["Danemark","Italie","Allemagne/États-Unis","États-Unis"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15276: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Underground (Podzemlje), réalisé par Emir Kusturica, a-t-il remporté la Palme d’Or ?",
    answers: ["1985","1995","1990","1994"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15277: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Emir Kusturica, a remporté la Palme d’Or en 1995 ?",
    answers: ["L’Arbre de vie","Underground","Secrets et mensonges","Les Meilleures Intentions"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15278: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1995 avec le film Underground (Podzemlje) ?",
    answers: ["Ermanno Olmi","Emir Kusturica","Shōhei Imamura","Bille August"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15279: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Underground (Podzemlje), qui a remporté la Palme d’Or en 1995 ?",
    answers: ["Thaïlande","Chine","Yougoslavie","Iran"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15280: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Secrets et mensonges (Secrets & Lies), réalisé par Mike Leigh, a-t-il remporté la Palme d’Or ?",
    answers: ["1993","1955","1996","1995"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15281: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Mike Leigh, a remporté la Palme d’Or en 1996 ?",
    answers: ["Secrets et mensonges","Pulp Fiction","Sexe, mensonges et vidéo","L’Arbre de vie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15282: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1996 avec le film Secrets et mensonges (Secrets & Lies) ?",
    answers: ["Mike Leigh","Akira Kurosawa","Jacques-Yves Cousteau et Louis Malle","Gus Van Sant"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15283: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Secrets et mensonges (Secrets & Lies), qui a remporté la Palme d’Or en 1996 ?",
    answers: ["Yougoslavie","Iran","États-Unis","Royaume-Uni"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15284: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le Goût de la cerise (Ta’m e guilass), réalisé par Abbas Kiarostami, a-t-il remporté la Palme d’Or ?",
    answers: ["1991","1984","1997","1998"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15285: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Abbas Kiarostami, a remporté la Palme d’Or en 1997 ?",
    answers: ["Missing : Porté disparu","Underground","Paris, Texas","Le Goût de la cerise"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15286: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1997 avec le film Le Goût de la cerise (Ta’m e guilass) ?",
    answers: ["Abbas Kiarostami","Federico Fellini","Mike Leigh","Roland Joffé"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15287: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le Goût de la cerise (Ta’m e guilass), qui a remporté la Palme d’Or en 1997 ?",
    answers: ["France","Royaume-Uni","Iran","Pologne/France"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15288: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année L’Anguille (Unagi), réalisé par Shōhei Imamura, a-t-il remporté la Palme d’Or ?",
    answers: ["1999","1998","2000","1997"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15289: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Shōhei Imamura, a remporté la Palme d’Or en 1997 ?",
    answers: ["L’Anguille","L'Éternité et un jour","Secrets et mensonges","Dancer in the Dark"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15290: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1997 avec le film L’Anguille (Unagi) ?",
    answers: ["Nanni Moretti","Jean-Pierre & Luc Dardenne","Shōhei Imamura","Quentin Tarantino"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15291: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient L’Anguille (Unagi), qui a remporté la Palme d’Or en 1997 ?",
    answers: ["Japon","États-Unis","Belgique","Yougoslavie"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15292: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année L'Éternité et un jour (Mia aioniotita kai mia mera), réalisé par Theo Angelopoulos, a-t-il remporté la Palme d’Or ?",
    answers: ["1998","2003","1984","1951"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15293: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Theo Angelopoulos, a remporté la Palme d’Or en 1998 ?",
    answers: ["The Square","L'Éternité et un jour","Underground","La Dernière Chance"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15294: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1998 avec le film L'Éternité et un jour (Mia aioniotita kai mia mera) ?",
    answers: ["Luchino Visconti","Bodil Ipsen et Lau Lauritzen Jr.","Theo Angelopoulos","Apichatpong Weerasethakul"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15295: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient L'Éternité et un jour (Mia aioniotita kai mia mera), qui a remporté la Palme d’Or en 1998 ?",
    answers: ["Iran","Grèce","Espagne/Mexique","Italie"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15296: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Rosetta, réalisé par Jean-Pierre & Luc Dardenne, a-t-il remporté la Palme d’Or ?",
    answers: ["2000","1996","1992","1999"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15297: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Jean-Pierre & Luc Dardenne, a remporté la Palme d’Or en 1999 ?",
    answers: ["Anora","Rosetta","Dheepan","Le Goût de la cerise"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15298: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 1999 avec le film Rosetta ?",
    answers: ["Gus Van Sant","Jane Campion","Jean-Pierre & Luc Dardenne","Roman Polanski"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15299: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Rosetta, qui a remporté la Palme d’Or en 1999 ?",
    answers: ["Belgique","Italie","Autriche/Allemagne","Suède"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15300: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Dancer in the Dark, réalisé par Lars von Trier, a-t-il remporté la Palme d’Or ?",
    answers: ["2005","1956","2001","2000"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15301: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Lars von Trier, a remporté la Palme d’Or en 2000 ?",
    answers: ["La Chambre du fils","L'Éternité et un jour","Le Poison","Dancer in the Dark"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15302: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2000 avec le film Dancer in the Dark ?",
    answers: ["Lars von Trier","Joel & Ethan Coen","Anselmo Duarte","Ermanno Olmi"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15303: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Dancer in the Dark, qui a remporté la Palme d’Or en 2000 ?",
    answers: ["Nouvelle-Zélande/Australie","Danemark","France","Pologne/France"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15304: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Chambre du fils (La stanza del figlio), réalisé par Nanni Moretti, a-t-il remporté la Palme d’Or ?",
    answers: ["1987","2001","1999","2017"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15305: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Nanni Moretti, a remporté la Palme d’Or en 2001 ?",
    answers: ["Un homme et une femme","La Chambre du fils","Rosetta","Le Pianiste"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15306: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2001 avec le film La Chambre du fils (La stanza del figlio) ?",
    answers: ["Nanni Moretti","Ruben Östlund","Gus Van Sant","Theo Angelopoulos"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15307: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Chambre du fils (La stanza del figlio), qui a remporté la Palme d’Or en 2001 ?",
    answers: ["France","Danemark","Italie","Iran"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15308: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le Pianiste (The Pianist), réalisé par Roman Polanski, a-t-il remporté la Palme d’Or ?",
    answers: ["2004","2001","2002","2003"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15309: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Roman Polanski, a remporté la Palme d’Or en 2002 ?",
    answers: ["Le vent se lève","Amour","Moi, Daniel Blake","Le Pianiste"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15310: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2002 avec le film Le Pianiste (The Pianist) ?",
    answers: ["Orson Welles","Laurent Cantet","Costa-Gavras","Roman Polanski"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15311: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le Pianiste (The Pianist), qui a remporté la Palme d’Or en 2002 ?",
    answers: ["États-Unis","Royaume-Uni","Pologne/France","Italie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15312: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Elephant, réalisé par Gus Van Sant, a-t-il remporté la Palme d’Or ?",
    answers: ["1975","2001","1998","2003"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15313: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Gus Van Sant, a remporté la Palme d’Or en 2003 ?",
    answers: ["Tourments","Yol, la permission","Elephant","Le vent se lève"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15314: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2003 avec le film Elephant ?",
    answers: ["Quentin Tarantino","Bob Fosse","Jean-Pierre & Luc Dardenne","Gus Van Sant"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15315: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Elephant, qui a remporté la Palme d’Or en 2003 ?",
    answers: ["France","États-Unis","Italie","Belgique"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15316: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Fahrenheit 9/11, réalisé par Michael Moore, a-t-il remporté la Palme d’Or ?",
    answers: ["1999","2004","2003","1974"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15317: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Michael Moore, a remporté la Palme d’Or en 2004 ?",
    answers: ["L’Enfant","Fahrenheit 9/11","Moi, Daniel Blake","The Square"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15318: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2004 avec le film Fahrenheit 9/11 ?",
    answers: ["Michael Haneke","Lars von Trier","Michael Moore","Emir Kusturica"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15319: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Fahrenheit 9/11, qui a remporté la Palme d’Or en 2004 ?",
    answers: ["Nouvelle-Zélande/Australie","États-Unis","Japon","Royaume-Uni"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15320: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année L’Enfant, réalisé par Jean-Pierre & Luc Dardenne, a-t-il remporté la Palme d’Or ?",
    answers: ["2003","2004","2009","2005"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15321: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Jean-Pierre & Luc Dardenne, a remporté la Palme d’Or en 2005 ?",
    answers: ["Un homme et une femme","Le vent se lève","L’Enfant","Entre les murs"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15322: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2005 avec le film L’Enfant ?",
    answers: ["Michael Haneke","Michael Moore","Gus Van Sant","Jean-Pierre & Luc Dardenne"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15323: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient L’Enfant, qui a remporté la Palme d’Or en 2005 ?",
    answers: ["Nouvelle-Zélande/Australie","Italie","Belgique","Autriche/France"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15324: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le vent se lève (The Wind That Shakes the Barley), réalisé par Ken Loach, a-t-il remporté la Palme d’Or ?",
    answers: ["2009","1984","2006","2003"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15325: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Ken Loach, a remporté la Palme d’Or en 2006 ?",
    answers: ["Underground","Le vent se lève","Les Parapluies de Cherbourg","4 mois, 3 semaines, 2 jours"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15326: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2006 avec le film Le vent se lève (The Wind That Shakes the Barley) ?",
    answers: ["Michael Moore","Ken Loach","Laurent Cantet","Jean-Pierre & Luc Dardenne"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15327: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le vent se lève (The Wind That Shakes the Barley), qui a remporté la Palme d’Or en 2006 ?",
    answers: ["Belgique","France","États-Unis","Royaume-Uni"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15328: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année 4 mois, 3 semaines, 2 jours (4 luni, 3 săptămâni și 2 zile), réalisé par Cristian Mungiu, a-t-il remporté la Palme d’Or ?",
    answers: ["2007","1939","2008","1953"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15329: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Cristian Mungiu, a remporté la Palme d’Or en 2007 ?",
    answers: ["L’Arbre de vie","Dumbo","L’Enfant","4 mois, 3 semaines, 2 jours"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15330: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2007 avec le film 4 mois, 3 semaines, 2 jours (4 luni, 3 săptămâni și 2 zile) ?",
    answers: ["Ken Loach","Lindsay Anderson","Cristian Mungiu","Jean-Pierre & Luc Dardenne"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15331: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient 4 mois, 3 semaines, 2 jours (4 luni, 3 săptămâni și 2 zile), qui a remporté la Palme d’Or en 2007 ?",
    answers: ["Roumanie","Japon","Autriche/France","Pologne/France"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15332: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Entre les murs, réalisé par Laurent Cantet, a-t-il remporté la Palme d’Or ?",
    answers: ["2011","2007","2008","2012"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15333: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Laurent Cantet, a remporté la Palme d’Or en 2008 ?",
    answers: ["Entre les murs","La Vie d’Adèle","Dancer in the Dark","Le Guépard"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15334: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2008 avec le film Entre les murs ?",
    answers: ["Apichatpong Weerasethakul","Laurent Cantet","Michael Haneke","Abbas Kiarostami"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15335: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Entre les murs, qui a remporté la Palme d’Or en 2008 ?",
    answers: ["États-Unis","Royaume-Uni","France","Yougoslavie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15336: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Le Ruban blanc (Das weiße Band), réalisé par Michael Haneke, a-t-il remporté la Palme d’Or ?",
    answers: ["2019","2009","2000","2012"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15337: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Michael Haneke, a remporté la Palme d’Or en 2009 ?",
    answers: ["L’Anguille","Le Ruban blanc","Moi, Daniel Blake","4 mois, 3 semaines, 2 jours"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15338: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2009 avec le film Le Ruban blanc (Das weiße Band) ?",
    answers: ["Bong Joon-ho","Michael Haneke","Roman Polanski","David Lynch"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15339: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Le Ruban blanc (Das weiße Band), qui a remporté la Palme d’Or en 2009 ?",
    answers: ["États-Unis","Autriche/Allemagne","France","Chine"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15340: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Oncle Boonmee, celui qui se souvient de ses vies antérieures (Lung Boonmee Raluek Chat), réalisé par Apichatpong Weerasethakul, a-t-il remporté la Palme d’Or ?",
    answers: ["2010","2018","2008","2000"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15341: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Apichatpong Weerasethakul, a remporté la Palme d’Or en 2010 ?",
    answers: ["L’Arbre de vie","Oncle Boonmee, celui qui se souvient de ses vies antérieures","Entre les murs","Une affaire de famille"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15342: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2010 avec le film Oncle Boonmee, celui qui se souvient de ses vies antérieures (Lung Boonmee Raluek Chat) ?",
    answers: ["Apichatpong Weerasethakul","Teinosuke Kinugasa","Nuri Bilge Ceylan","Bob Fosse"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15343: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Oncle Boonmee, celui qui se souvient de ses vies antérieures (Lung Boonmee Raluek Chat), qui a remporté la Palme d’Or en 2010 ?",
    answers: ["France","États-Unis","Thaïlande","Suède"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15344: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année L’Arbre de vie (The Tree of Life), réalisé par Terrence Malick, a-t-il remporté la Palme d’Or ?",
    answers: ["2005","2011","2013","2016"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15345: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Terrence Malick, a remporté la Palme d’Or en 2011 ?",
    answers: ["Winter Sleep","Adieu ma concubine","L’Arbre de vie","Oncle Boonmee, celui qui se souvient de ses vies antérieures"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15346: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2011 avec le film L’Arbre de vie (The Tree of Life) ?",
    answers: ["Michael Haneke","Terrence Malick","Ruben Östlund","Quentin Tarantino"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15347: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient L’Arbre de vie (The Tree of Life), qui a remporté la Palme d’Or en 2011 ?",
    answers: ["États-Unis","Italie","France","Allemagne"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15348: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Amour, réalisé par Michael Haneke, a-t-il remporté la Palme d’Or ?",
    answers: ["2014","1995","2012","2010"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15349: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Michael Haneke, a remporté la Palme d’Or en 2012 ?",
    answers: ["La terre sera rouge","Oncle Boonmee, celui qui se souvient de ses vies antérieures","Le Ruban blanc","Amour"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15350: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2012 avec le film Amour ?",
    answers: ["Alf Sjöberg","Abdellatif Kechiche","Ruben Östlund","Michael Haneke"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15351: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Amour, qui a remporté la Palme d’Or en 2012 ?",
    answers: ["Turquie","France","Japon","Autriche/France"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15352: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année La Vie d’Adèle (La Vie d’Adèle – Chapitres 1 & 2), réalisé par Abdellatif Kechiche, a-t-il remporté la Palme d’Or ?",
    answers: ["1987","2013","1989","2016"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15353: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Abdellatif Kechiche, a remporté la Palme d’Or en 2013 ?",
    answers: ["The Square","Amour","La Vie d’Adèle","Winter Sleep"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15354: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2013 avec le film La Vie d’Adèle (La Vie d’Adèle – Chapitres 1 & 2) ?",
    answers: ["Abdellatif Kechiche","Michael Haneke","Bong Joon-ho","Jacques Audiard"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15355: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient La Vie d’Adèle (La Vie d’Adèle – Chapitres 1 & 2), qui a remporté la Palme d’Or en 2013 ?",
    answers: ["États-Unis","Mexique","Autriche/France","France"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15356: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Winter Sleep (Kış Uykusu), réalisé par Nuri Bilge Ceylan, a-t-il remporté la Palme d’Or ?",
    answers: ["2009","1963","2015","2014"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15357: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Nuri Bilge Ceylan, a remporté la Palme d’Or en 2014 ?",
    answers: ["Tourments","Le Knack… et comment l’avoir","Winter Sleep","The Square"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15358: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2014 avec le film Winter Sleep (Kış Uykusu) ?",
    answers: ["Abdellatif Kechiche","Nuri Bilge Ceylan","Apichatpong Weerasethakul","Jacques Audiard"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15359: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Winter Sleep (Kış Uykusu), qui a remporté la Palme d’Or en 2014 ?",
    answers: ["Turquie","France","Royaume-Uni","États-Unis"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15360: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Dheepan, réalisé par Jacques Audiard, a-t-il remporté la Palme d’Or ?",
    answers: ["1939","1997","2015","2014"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15361: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Jacques Audiard, a remporté la Palme d’Or en 2015 ?",
    answers: ["Amour","Dheepan","Titane","Winter Sleep"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15362: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2015 avec le film Dheepan ?",
    answers: ["Abdellatif Kechiche","Jacques Audiard","Nuri Bilge Ceylan","David Lean"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15363: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Dheepan, qui a remporté la Palme d’Or en 2015 ?",
    answers: ["Turquie","Suède","France","États-Unis"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15364: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Moi, Daniel Blake (I, Daniel Blake), réalisé par Ken Loach, a-t-il remporté la Palme d’Or ?",
    answers: ["2016","2017","1955","1998"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15365: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Ken Loach, a remporté la Palme d’Or en 2016 ?",
    answers: ["Moi, Daniel Blake","Amour","Fahrenheit 9/11","Une affaire de famille"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15366: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2016 avec le film Moi, Daniel Blake (I, Daniel Blake) ?",
    answers: ["Ken Loach","Apichatpong Weerasethakul","Bong Joon-ho","Julia Ducournau"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15367: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Moi, Daniel Blake (I, Daniel Blake), qui a remporté la Palme d’Or en 2016 ?",
    answers: ["Suède","États-Unis","Royaume-Uni","Japon"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15368: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année The Square, réalisé par Ruben Östlund, a-t-il remporté la Palme d’Or ?",
    answers: ["2017","2005","2022","2018"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15369: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Ruben Östlund, a remporté la Palme d’Or en 2017 ?",
    answers: ["The Square","Oncle Boonmee, celui qui se souvient de ses vies antérieures","Winter Sleep","Orfeu Negro"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15370: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2017 avec le film The Square ?",
    answers: ["Roberto Rossellini","Ken Loach","Justine Triet","Ruben Östlund"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15371: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient The Square, qui a remporté la Palme d’Or en 2017 ?",
    answers: ["Suède","Japon","Turquie","États-Unis"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15372: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Une affaire de famille (Manbiki Kazoku), réalisé par Hirokazu Kore-eda, a-t-il remporté la Palme d’Or ?",
    answers: ["2019","2018","2004","1991"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15373: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Hirokazu Kore-eda, a remporté la Palme d’Or en 2018 ?",
    answers: ["Moi, Daniel Blake","Une affaire de famille","Winter Sleep","Le Pianiste"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15374: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2018 avec le film Une affaire de famille (Manbiki Kazoku) ?",
    answers: ["Michael Haneke","Hirokazu Kore-eda","Ruben Östlund","Marcel Camus"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15375: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Une affaire de famille (Manbiki Kazoku), qui a remporté la Palme d’Or en 2018 ?",
    answers: ["Japon","Grèce","Royaume-Uni","France"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15376: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Parasite (Gisaengchung), réalisé par Bong Joon-ho, a-t-il remporté la Palme d’Or ?",
    answers: ["2016","2019","2015","2018"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15377: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Bong Joon-ho, a remporté la Palme d’Or en 2019 ?",
    answers: ["Parasite","Le Pianiste","Moi, Daniel Blake","Anatomie d’une chute"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15378: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2019 avec le film Parasite (Gisaengchung) ?",
    answers: ["Hirokazu Kore-eda","Michael Haneke","Roman Polanski","Bong Joon-ho"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15379: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Parasite (Gisaengchung), qui a remporté la Palme d’Or en 2019 ?",
    answers: ["Suède","Espagne/Mexique","Corée du Sud","Japon"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15380: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Titane, réalisé par Julia Ducournau, a-t-il remporté la Palme d’Or ?",
    answers: ["2021","2019","2013","2024"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15381: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Julia Ducournau, a remporté la Palme d’Or en 2021 ?",
    answers: ["The Square","Titane","Anora","Yol, la permission"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15382: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2021 avec le film Titane ?",
    answers: ["Ruben Östlund","Julia Ducournau","Michael Moore","Shōhei Imamura"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15383: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Titane, qui a remporté la Palme d’Or en 2021 ?",
    answers: ["États-Unis","Suède","Japon","France"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15384: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Sans filtre (Triangle of Sadness), réalisé par Ruben Östlund, a-t-il remporté la Palme d’Or ?",
    answers: ["1983","2014","2022","2018"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15385: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Ruben Östlund, a remporté la Palme d’Or en 2022 ?",
    answers: ["Titane","Anora","Sans filtre","Les Maudits"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15386: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2022 avec le film Sans filtre (Triangle of Sadness) ?",
    answers: ["David Lynch","Ruben Östlund","Ken Loach","Michelangelo Antonioni"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15387: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Sans filtre (Triangle of Sadness), qui a remporté la Palme d’Or en 2022 ?",
    answers: ["Belgique","France","États-Unis","Suède"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id15388: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Anatomie d’une chute, réalisé par Justine Triet, a-t-il remporté la Palme d’Or ?",
    answers: ["1957","2022","2023","2014"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15389: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Justine Triet, a remporté la Palme d’Or en 2023 ?",
    answers: ["Une affaire de famille","Moi, Daniel Blake","Anatomie d’une chute","La Leçon de piano"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15390: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2023 avec le film Anatomie d’une chute ?",
    answers: ["Gus Van Sant","Jane Campion","Justine Triet","Bong Joon-ho"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15391: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Anatomie d’une chute, qui a remporté la Palme d’Or en 2023 ?",
    answers: ["Suède","France","États-Unis","Royaume-Uni"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id15392: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "En quelle année Anora, réalisé par Sean Baker, a-t-il remporté la Palme d’Or ?",
    answers: ["2001","1953","2024","1978"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15393: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel film, réalisé par Sean Baker, a remporté la Palme d’Or en 2024 ?",
    answers: ["Anora","Dancer in the Dark","Adieu ma concubine","Les Meilleures Intentions"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id15394: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "Quel réalisateur a remporté la Palme d’Or en 2024 avec le film Anora ?",
    answers: ["Bong Joon-ho","Julia Ducournau","Sean Baker","Michael Haneke"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id15395: {
    themes: ["Cinéma","Culture Pop","Divers"],
    question: "De quel pays provient Anora, qui a remporté la Palme d’Or en 2024 ?",
    answers: ["Royaume-Uni","Allemagne","France","États-Unis"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
};
  export default dataDivertissement;
//  module.exports = dataDivertissement;